var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5AxTandemTandem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3095.24 803.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199{stroke-width:0px;}.cls-2,.cls-196{fill:#414042;}.cls-3,.cls-6,.cls-7,.cls-75,.cls-200,.cls-179,.cls-180,.cls-182,.cls-192,.cls-193,.cls-196,.cls-198{mix-blend-mode:multiply;}.cls-3,.cls-169{fill:#f1f2f2;}.cls-4{fill:url(#New_Gradient_Swatch_4);}.cls-5{fill:url(#New_Gradient_Swatch_3);}.cls-6{fill:url(#linear-gradient-67);}.cls-7{fill:url(#linear-gradient-66);}.cls-8{fill:url(#New_Gradient_Swatch_3-3);}.cls-9{fill:url(#New_Gradient_Swatch_3-4);}.cls-10{fill:url(#New_Gradient_Swatch_3-9);}.cls-11{fill:url(#New_Gradient_Swatch_3-8);}.cls-12{fill:url(#New_Gradient_Swatch_3-7);}.cls-13{fill:url(#New_Gradient_Swatch_3-6);}.cls-14{fill:url(#New_Gradient_Swatch_3-2);}.cls-15{fill:url(#New_Gradient_Swatch_3-5);}.cls-16{fill:url(#New_Gradient_Swatch_4-3);}.cls-17{fill:url(#New_Gradient_Swatch_4-2);}.cls-18{fill:url(#New_Gradient_Swatch_4-4);}.cls-19{fill:url(#New_Gradient_Swatch_4-5);}.cls-20{fill:#f7941d;}.cls-21{fill:url(#linear-gradient-120);}.cls-22{fill:url(#linear-gradient-125);}.cls-23{fill:url(#linear-gradient-124);}.cls-24{fill:url(#linear-gradient-126);}.cls-25{fill:url(#linear-gradient-138);}.cls-26{fill:url(#linear-gradient-139);}.cls-27{fill:url(#linear-gradient-134);}.cls-28{fill:url(#linear-gradient-131);}.cls-29{fill:url(#linear-gradient-136);}.cls-30{fill:url(#linear-gradient-132);}.cls-31{fill:url(#linear-gradient-135);}.cls-32{fill:url(#linear-gradient-130);}.cls-33{fill:url(#linear-gradient-137);}.cls-34{fill:url(#linear-gradient-100);}.cls-35{fill:url(#linear-gradient-101);}.cls-36{fill:url(#linear-gradient-123);}.cls-37{fill:url(#linear-gradient-129);}.cls-38{fill:url(#linear-gradient-121);}.cls-39{fill:url(#linear-gradient-122);}.cls-40{fill:url(#linear-gradient-109);}.cls-41{fill:url(#linear-gradient-108);}.cls-42{fill:url(#linear-gradient-106);}.cls-43{fill:url(#linear-gradient-102);}.cls-44{fill:url(#linear-gradient-104);}.cls-45{fill:url(#linear-gradient-103);}.cls-46{fill:url(#linear-gradient-105);}.cls-47{fill:url(#linear-gradient-117);}.cls-48{fill:url(#linear-gradient-118);}.cls-49{fill:url(#linear-gradient-111);}.cls-50{fill:url(#linear-gradient-112);}.cls-51{fill:url(#linear-gradient-127);}.cls-52{fill:url(#linear-gradient-128);}.cls-53{fill:url(#linear-gradient-110);}.cls-54{fill:url(#linear-gradient-113);}.cls-55{fill:url(#linear-gradient-114);}.cls-56{fill:url(#linear-gradient-115);}.cls-57{fill:url(#linear-gradient-116);}.cls-58{fill:url(#linear-gradient-119);}.cls-59{fill:url(#linear-gradient-144);}.cls-60{fill:url(#linear-gradient-145);}.cls-61{fill:url(#linear-gradient-149);}.cls-62{fill:url(#linear-gradient-148);}.cls-63{fill:url(#linear-gradient-146);}.cls-64{fill:url(#linear-gradient-143);}.cls-65{fill:url(#linear-gradient-140);}.cls-66{fill:url(#linear-gradient-141);}.cls-67{fill:url(#linear-gradient-147);}.cls-68{fill:url(#linear-gradient-142);}.cls-69{fill:url(#linear-gradient-154);}.cls-70{fill:url(#linear-gradient-152);}.cls-71{fill:url(#linear-gradient-155);}.cls-72{fill:url(#linear-gradient-151);}.cls-73{fill:url(#linear-gradient-153);}.cls-74{fill:url(#linear-gradient-150);}.cls-201{mask:url(#mask);}.cls-75{fill:#fff;}.cls-76,.cls-179{fill:#ed1c24;}.cls-77{fill:url(#linear-gradient);}.cls-202{filter:url(#luminosity-noclip);}.cls-78{fill:#ef4136;}.cls-79{fill:#6d6e71;}.cls-80{fill:#f15a29;}.cls-81{fill:url(#linear-gradient-38);}.cls-82{fill:url(#linear-gradient-33);}.cls-83{fill:url(#linear-gradient-29);}.cls-84{fill:url(#linear-gradient-32);}.cls-85{fill:url(#linear-gradient-30);}.cls-86{fill:url(#linear-gradient-31);}.cls-87{fill:url(#linear-gradient-36);}.cls-88{fill:url(#linear-gradient-39);}.cls-89{fill:url(#linear-gradient-34);}.cls-90{fill:url(#linear-gradient-37);}.cls-91{fill:url(#linear-gradient-35);}.cls-92{fill:url(#linear-gradient-28);}.cls-93{fill:url(#linear-gradient-25);}.cls-94{fill:url(#linear-gradient-11);}.cls-95{fill:url(#linear-gradient-12);}.cls-96{fill:url(#linear-gradient-13);}.cls-97{fill:url(#linear-gradient-10);}.cls-98{fill:url(#linear-gradient-17);}.cls-99{fill:url(#linear-gradient-16);}.cls-100{fill:url(#linear-gradient-19);}.cls-101{fill:url(#linear-gradient-15);}.cls-102{fill:url(#linear-gradient-23);}.cls-103{fill:url(#linear-gradient-21);}.cls-104{fill:url(#linear-gradient-18);}.cls-105{fill:url(#linear-gradient-14);}.cls-106{fill:url(#linear-gradient-22);}.cls-107{fill:url(#linear-gradient-20);}.cls-108{fill:url(#linear-gradient-27);}.cls-109{fill:url(#linear-gradient-24);}.cls-110{fill:url(#linear-gradient-26);}.cls-111{fill:url(#linear-gradient-45);}.cls-112{fill:url(#linear-gradient-46);}.cls-113{fill:url(#linear-gradient-44);}.cls-114{fill:url(#linear-gradient-48);}.cls-115{fill:url(#linear-gradient-49);}.cls-116{fill:url(#linear-gradient-47);}.cls-117{fill:url(#linear-gradient-42);}.cls-118{fill:url(#linear-gradient-43);}.cls-119{fill:url(#linear-gradient-40);}.cls-120{fill:url(#linear-gradient-41);}.cls-121{fill:url(#linear-gradient-59);}.cls-122{fill:url(#linear-gradient-57);}.cls-123{fill:url(#linear-gradient-58);}.cls-124{fill:url(#linear-gradient-55);}.cls-125{fill:url(#linear-gradient-56);}.cls-126{fill:url(#linear-gradient-53);}.cls-127{fill:url(#linear-gradient-51);}.cls-128{fill:url(#linear-gradient-52);}.cls-129{fill:url(#linear-gradient-50);}.cls-130{fill:url(#linear-gradient-54);}.cls-131{fill:url(#linear-gradient-60);}.cls-132{fill:url(#linear-gradient-61);}.cls-133{fill:url(#linear-gradient-62);}.cls-134{fill:url(#linear-gradient-65);}.cls-135{fill:url(#linear-gradient-79);}.cls-136{fill:url(#linear-gradient-78);}.cls-137{fill:url(#linear-gradient-77);}.cls-138{fill:url(#linear-gradient-75);}.cls-139{fill:url(#linear-gradient-76);}.cls-140{fill:url(#linear-gradient-74);}.cls-141{fill:url(#linear-gradient-68);}.cls-142{fill:url(#linear-gradient-63);}.cls-143{fill:url(#linear-gradient-69);}.cls-144{fill:url(#linear-gradient-64);}.cls-145{fill:url(#linear-gradient-71);}.cls-146{fill:url(#linear-gradient-72);}.cls-147{fill:url(#linear-gradient-70);}.cls-148{fill:url(#linear-gradient-73);}.cls-149{fill:url(#linear-gradient-84);}.cls-150{fill:url(#linear-gradient-85);}.cls-151{fill:url(#linear-gradient-82);}.cls-152{fill:url(#linear-gradient-83);}.cls-153{fill:url(#linear-gradient-89);}.cls-154{fill:url(#linear-gradient-88);}.cls-155{fill:url(#linear-gradient-86);}.cls-156{fill:url(#linear-gradient-87);}.cls-157{fill:url(#linear-gradient-80);}.cls-158{fill:url(#linear-gradient-81);}.cls-159{fill:url(#linear-gradient-98);}.cls-160{fill:url(#linear-gradient-91);}.cls-161{fill:url(#linear-gradient-92);}.cls-162{fill:url(#linear-gradient-93);}.cls-163{fill:url(#linear-gradient-90);}.cls-164{fill:url(#linear-gradient-96);}.cls-165{fill:url(#linear-gradient-97);}.cls-166{fill:url(#linear-gradient-94);}.cls-167{fill:url(#linear-gradient-95);}.cls-168{fill:url(#linear-gradient-99);}.cls-170{fill:#58595b;}.cls-171,.cls-180{fill:#bcbec0;}.cls-172{fill:#808285;}.cls-173{fill:url(#New_Gradient_Swatch_3-12);}.cls-174{fill:url(#New_Gradient_Swatch_3-11);}.cls-175{fill:url(#New_Gradient_Swatch_3-10);}.cls-176,.cls-183{fill:#000;}.cls-177,.cls-182{fill:#a7a9ac;}.cls-178{fill:url(#New_Gradient_Swatch_11_cop);}.cls-181{fill:#be1e2d;}.cls-183{opacity:.5;}.cls-184{fill:url(#linear-gradient-4);}.cls-185{fill:url(#linear-gradient-2);}.cls-186{fill:url(#linear-gradient-3);}.cls-187{fill:url(#linear-gradient-8);}.cls-188{fill:url(#linear-gradient-9);}.cls-189{fill:url(#linear-gradient-7);}.cls-190{fill:url(#linear-gradient-5);}.cls-191{fill:url(#linear-gradient-6);}.cls-192{fill:url(#linear-gradient-133);}.cls-193{fill:url(#linear-gradient-107);}.cls-194,.cls-198{fill:#939598;}.cls-203{isolation:isolate;}.cls-195{fill:#e6e7e8;}.cls-197{fill:#d1d3d4;}.cls-199{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 716.2,
    width: 3095.24,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 716.2,
    width: 3095.24,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3096,
    height: 88,
    transform: "translate(-.61 715.94)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4120.39,
    y1: 449.26,
    x2: -4120.39,
    y2: 352.94,
    gradientTransform: "translate(-3595.37) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b7b8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4082.97,
    y1: 490.56,
    x2: -4082.97,
    y2: 311.88,
    gradientTransform: "translate(-3595.37) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -4061.49,
    y1: 308.9,
    x2: -4061.49,
    y2: 493.36,
    gradientTransform: "translate(-3595.37) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 618.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 308.89,
    y2: 493.35,
    gradientTransform: "translate(4527.6 624.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 630.42) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 638.08) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 647.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 657.16) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 668.33) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 680.43) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 693.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 707.63) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 722.49) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 737.8) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 308.9,
    y2: 493.36,
    gradientTransform: "translate(4527.6 753.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 770.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 786.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -4061.49,
    y1: 308.9,
    x2: -4061.49,
    y2: 493.36,
    gradientTransform: "translate(4527.6 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -4104.46,
    x2: -4104.46,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 618.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.35,
    gradientTransform: "translate(4613.54 624.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 630.42) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 638.08) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 647.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 657.16) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 668.33) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 680.43) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 693.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 707.63) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 722.49) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 737.8) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 753.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 770.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 786.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -4082.97,
    y1: 310.39,
    x2: -4082.97,
    y2: 493.86,
    gradientTransform: "translate(4570.57 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 159.36,
    y1: 400.05,
    x2: 159.36,
    y2: 259.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 306.57,
    y1: 400.05,
    x2: 306.57,
    y2: 259.24,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 398.49,
    y1: 491.35,
    x2: 398.49,
    y2: 409.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1f0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#640000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 321.62,
    y1: 1218.61,
    x2: 321.62,
    y2: 1137.05,
    gradientTransform: "translate(736.41 1653.92) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 181.43,
    y1: 1271.58,
    x2: 181.43,
    y2: 1339.41,
    gradientTransform: "translate(-12.44 1707.82) rotate(-153.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 181.43,
    y1: 1331.63,
    x2: 181.43,
    y2: 1278.55,
    gradientTransform: "translate(-379.67 1512.54) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#938167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 181.43,
    y1: 1284.3,
    x2: 181.43,
    y2: 1326.28,
    gradientTransform: "translate(596.22 1766.46) rotate(-180)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 181.43,
    y1: 1321.47,
    x2: 181.43,
    y2: 1288.62,
    gradientTransform: "translate(596.22 1766.46) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d8f8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 398.07,
    y1: 306.04,
    x2: 381.68,
    y2: 306.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 264.18,
    y1: 717.26,
    x2: 264.18,
    y2: 530.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 264.18,
    y1: 547.37,
    x2: 264.18,
    y2: 706.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 264.18,
    y1: 574.21,
    x2: 264.18,
    y2: 673.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    y1: 653.93,
    y2: 593.73,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 264.18,
    y1: 682.04,
    x2: 264.18,
    y2: 567.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 264.18,
    y1: 607.68,
    x2: 264.18,
    y2: 642.15,
    gradientTransform: "translate(829.98 251.07) rotate(79.55)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 264.18,
    y1: 637.74,
    x2: 264.18,
    y2: 610.89,
    gradientTransform: "translate(829.85 250.87) rotate(79.53)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 926.45,
    y1: 550.01,
    x2: 926.45,
    y2: 556.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    y1: 555.88,
    y2: 561.59,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    y1: 561.75,
    y2: 567.19,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    y1: 567.51,
    y2: 572.83,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    y1: 572.94,
    y2: 578.7,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    y1: 578.91,
    y2: 584.9,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    y1: 585.22,
    y2: 590.22,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 926.45,
    y1: 590.43,
    x2: 926.45,
    y2: 595.65,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    y1: 596.62,
    y2: 601.73,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 926.45,
    y1: 602.49,
    x2: 926.45,
    y2: 607.6,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    y1: 608.14,
    y2: 614.04,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 926.45,
    y1: 614.44,
    x2: 926.45,
    y2: 619.34,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 906.51,
    y1: 549.96,
    x2: 906.51,
    y2: 626.18,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 946.38,
    y1: 549.96,
    x2: 946.38,
    y2: 626.18,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 807.95,
    x2: 807.95,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 807.95,
    x2: 807.95,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 807.95,
    x2: 807.95,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 807.92,
    y1: 573.42,
    x2: 807.92,
    y2: 673.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 807.95,
    y1: 642.51,
    x2: 807.95,
    y2: 605.26,
    gradientTransform: "translate(677.94 -388.51) rotate(45)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 807.95,
    y1: 637.62,
    x2: 807.95,
    y2: 611,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 1044.64,
    x2: 1044.64,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 1044.64,
    x2: 1044.64,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1044.64,
    x2: 1044.64,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1044.61,
    x2: 1044.61,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1044.64,
    y1: 642.51,
    x2: 1044.64,
    y2: 605.26,
    gradientTransform: "translate(1412.03 -535.99) rotate(76.72)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1044.64,
    y1: 637.62,
    x2: 1044.64,
    y2: 611,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 551.95,
    y1: 520.54,
    x2: 551.95,
    y2: 657.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cccecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#bec0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a8aaad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#919396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#818285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6e6f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 459.91,
    y1: 640.48,
    x2: 459.91,
    y2: 665.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#212122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 551.95,
    x2: 551.95,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 643.98,
    x2: 643.98,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 586.62,
    y1: 525.3,
    x2: 611.02,
    y2: 525.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58595c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1926.83,
    y1: 540.94,
    x2: 1926.83,
    y2: 457.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9c9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#545152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1300.98,
    y1: 670.46,
    x2: 1300.98,
    y2: 514.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 1300.98,
    y1: 683.23,
    x2: 1300.98,
    y2: 691.17,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 1300.98,
    y1: 651.72,
    x2: 1300.98,
    y2: 682.75,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 1300.98,
    y1: 495.78,
    x2: 1300.98,
    y2: 636.74,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 2602.2,
    x2: 2602.2,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 2602.2,
    x2: 2602.2,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 2602.2,
    x2: 2602.2,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 2602.16,
    x2: 2602.16,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 2602.2,
    y1: 642.51,
    x2: 2602.2,
    y2: 605.26,
    gradientTransform: "translate(2611.73 -2051.88) rotate(76.72)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 2602.2,
    y1: 637.62,
    x2: 2602.2,
    y2: 611,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-5",
    x1: 2842.95,
    x2: 2842.95,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 2842.95,
    x2: 2842.95,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 2842.95,
    x2: 2842.95,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 2842.92,
    x2: 2842.92,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 2842.95,
    y1: 642.51,
    x2: 2842.95,
    y2: 605.26,
    gradientTransform: "translate(2797.17 -2286.19) rotate(76.72)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 2842.95,
    y1: 637.62,
    x2: 2842.95,
    y2: 611,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 2491.98,
    y1: 542.49,
    x2: 2491.98,
    y2: 462.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8d8f92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6c6d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#545456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 2485.04,
    x2: 2485.04,
    xlinkHref: "#linear-gradient-117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 2498.93,
    x2: 2498.93,
    xlinkHref: "#linear-gradient-117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 2720.56,
    x2: 2720.56,
    xlinkHref: "#linear-gradient-117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 2720.56,
    x2: 2720.56,
    xlinkHref: "#linear-gradient-117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 2713.62,
    x2: 2713.62,
    xlinkHref: "#linear-gradient-117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 2727.5,
    x2: 2727.5,
    xlinkHref: "#linear-gradient-117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 2942.19,
    x2: 2942.19,
    xlinkHref: "#linear-gradient-117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 2956.08,
    x2: 2956.08,
    xlinkHref: "#linear-gradient-117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 489.29,
    y1: 372.9,
    x2: 489.29,
    y2: 503.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 1848.9,
    y1: 502.52,
    x2: 1848.9,
    y2: 549.38,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 1983.77,
    y1: -952.83,
    x2: 1983.77,
    y2: -934.39,
    gradientTransform: "translate(5073.05 -406.21) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1869.85,
    y1: 505.05,
    x2: 1869.85,
    y2: 525.05,
    gradientTransform: "translate(1219.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 1852.27,
    y1: 479.38,
    x2: 1852.27,
    y2: 549.13,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-11",
    x1: 1860.27,
    y1: 458.4,
    x2: 1860.27,
    y2: 627.11,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-12",
    x1: 1860.27,
    y1: 574.52,
    x2: 1860.27,
    y2: 628.61,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 200.3,
    y1: 217.41,
    x2: 200.3,
    y2: 524.42,
    xlinkHref: "#linear-gradient-126"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 112.01,
    y1: 563.95,
    x2: 112.01,
    y2: 529.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 98.52,
    y1: 623.31,
    x2: 98.52,
    y2: 630.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 34.17,
    y1: 524.27,
    x2: 34.17,
    y2: 632.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 1929.29,
    y1: 1.17,
    x2: 1929.29,
    y2: 491.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 230.39,
    y1: 435.65,
    x2: 230.39,
    y2: 419.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 210.85,
    y1: 424.06,
    x2: 210.85,
    y2: 431.19,
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 248.42,
    y1: 424.06,
    x2: 248.42,
    y2: 431.19,
    gradientTransform: "translate(496.84 854.93) rotate(180)",
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 229.64,
    y1: 425.01,
    x2: 229.64,
    y2: 430.15,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 86.54,
    y1: 504.11,
    x2: 86.54,
    y2: 515.29,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 9.42,
    y1: 360.52,
    x2: 20.21,
    y2: 392.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 14.66,
    y1: 264.83,
    x2: 14.66,
    y2: 356.09,
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -5133.88,
    y1: 500.41,
    x2: -5133.88,
    y2: 488.97,
    gradientTransform: "translate(8075.67 989.12) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -5148.57,
    y1: 488.86,
    x2: -5148.57,
    y2: 500.92,
    gradientTransform: "translate(8105.05 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: -4419.78,
    x2: -4419.78,
    gradientTransform: "translate(6647.47 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: -4434.48,
    y1: 488.86,
    x2: -4434.48,
    y2: 500.92,
    gradientTransform: "translate(6676.85 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -3705.69,
    x2: -3705.69,
    gradientTransform: "translate(5219.28 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: -3720.38,
    y1: 488.86,
    x2: -3720.38,
    y2: 500.92,
    gradientTransform: "translate(5248.66 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: -2991.59,
    x2: -2991.59,
    gradientTransform: "translate(3791.08 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: -3006.28,
    y1: 488.86,
    x2: -3006.28,
    y2: 500.92,
    gradientTransform: "translate(3820.46 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 1622.81,
    y1: 666.29,
    x2: 1622.81,
    y2: 605.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 1916.67,
    x2: 1916.67,
    xlinkHref: "#linear-gradient-148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 2210.52,
    x2: 2210.52,
    xlinkHref: "#linear-gradient-148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 1769.74,
    y1: 662.69,
    x2: 1769.74,
    y2: 494.97,
    xlinkHref: "#linear-gradient-148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 2063.59,
    y1: 662.69,
    x2: 2063.59,
    y2: 494.97,
    xlinkHref: "#linear-gradient-148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: -4371.78,
    y1: 612.6,
    x2: -4371.78,
    gradientTransform: "translate(-2455.11) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: -4371.78,
    y1: 558.92,
    x2: -4371.78,
    y2: 551.73,
    gradientTransform: "translate(-2455.11) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -4371.78,
    x2: -4371.78,
    y2: 494.97,
    gradientTransform: "translate(-2455.11) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-148"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-201"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-200",
    width: 3096,
    height: 88,
    transform: "translate(-.61 715.94)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAADBgAAABYCAYAAADlNaVTAAAACXBIWXMAAAsSAAALEgHS3X78AAAgAElEQVR4nO3d7ZaiOtuu4TsBrTnn2v9dfcfTXULWDwjkE1BBEziPMbpFCBACWhaVyyhjjOn7Xuw/Y8w83RvpzZZlRoxbLlzW9+PzoZxdvu3Rrv/E4zhtjHnq+bCN8VjCMsFyY9dL/OsXlkX/+g1lxIgYI8bIYfNEZHyc58/z9ll2/7mLBGXWtjHUNb/O7Xabr5Xx+rvf71OZuC4y7cdbNu4nXT6e9/PzI3iXeWHJ1gLAJ71wLXMNo1jxxcl1jDptuJa5hlENk5jKzQBKlrmWuY4v736/v7imGS6fj19DV9uvf9+M/Z5vv9zn3MPyiVtcys9BFCt9cXI9o15PXNNcy6iGWXi2NBMo1co1zfWMKhnnf28W8P590WHyw652b/R792Td/o3X2O9378sqUYtllHpvuVvGLbs6rWSq2zArv43b7RbXw1nfnzdM3G43Zzvz9nPrD/uYN6LcR+8YhzJKidxu92hevL5b/iailKjxuRr+m57P0/Pz2+3mL1dDjXLr3m7tuP7SPz1PayW3Nr+OJOZN5bUWPW5DqeXptm2jZVrpeZ4etq2VlqZphuVaT8ts2WFesGyc1zRNNN/+s+tMz7WW1rselJo6UCulxKjhRau1FhER0xsRPXbyHk/w0CBGxMyNY5RIoxvRSkuve+l7LfJ4iOheTD/M0+Oj6rXI+Nje9RwuMEZ+f39F9UZ6JSK9fcPupRctuu+l11p+2mYOIphefv/+DtNaiemNKNupfjw2NYYF2p/71Ln/79+/0mstujdidC+9caeN6L4Xo7W0bSvGGPnz58+m8EA/doCX5DqyuO7t1o7ruB3tg3WDoMDtfpM/f/5sDBQMz2/3m/z535/peapDf7jsfr9Px7N1vZ/7z9R+zwUhhjeNuI3cwIf/799//10NKaTCDCJG7vef9L76eB/Xse0n9+af7/yy9CGctzrteN44Zx+23uCEp0r05nnjnH3Ri0FFztmXcd6O9PnOgRtDaVWdv7P9Yf5sxyNyvj80czzlM4mp3IwaZI6nymOxEsfE8Tzlv//+O3YHRdn5ftnThfE67nXWjXuedeO+Z72491m35RPAuSvdC/dBOW+bEZIGAAB7+r//+z9/RqpTfsB2ks/eW3U6zbv7WAsJeNNjPf7777+oTl4YYFz2+/u7WOf4GNTwheHWyudRrbXc77dgv049gnlaazFi5jDVYvl5nfvdBgyGeWEwwQ0oNGO/9vvtng8u2G0pNZW/3e9xgMEJJdh5jdbT+u0Y4FBOv/k5WDDM07a8EicsMIcVtBNYGDrzN04oQabQgF0nLq/nbTVzSCB+dEMG6VCELZ8MTMynZwgYhMkVGzSYAgM2lqSGC0krLUZ1IqJlaHMlRvUivW3g8Rv+lRFlhgBC0zSijJJe9aJFe6EA+03+vTEiuhdthuW32338VvpO+r4XpW5iR0CYRwroxSgj2pghGPCPHtbp5hEVmqZZ7Mzftq103bCPzhnNoR3X80YkcEdJSAYDUp3h1//F64n/KGMwwFluv6nf7ZwvwTqp57f73Zs/rZsMC8z7stNDibhMOO9+//HW+fmZO+9HbbgykoO7rrsf95/dlw0Y5MqKDNdWuF6yfPDc3Uf9nrtL8fQ9jdPfBDmw/U7fdtb2A6X9Uvij+Hv4w/T7dvjj4tMFj/X6t0SUiJ/z+6Ad98PP/f0c0Ja04z4lL9mOInyu2tP5Pl99z05tSTu+X+LybWi90UFsU4HXnSNgwOf293Gv8338zvM+PqO/jzZ8H7/f7IPP4+/js/j73vwMvrnQmfF7DAAAuJi1cEGik3z0uURJUCIdDAjDBnOQwN+I8qbzy/T/9LgXI2N33YntA9u2rbh9fX/uP9l17Ly2mdfxAglR+cGwj9laPxy//NjnONeGtuO+fTK2yRB8cMo6p3Aqr+Yze7/dvOd2urGjDog7+oFMIxKMJ03sqWuaNhk4uN3aMeQwhw+apvHCAuEoCXoc7cCGHhqt/bBBGDyYwhbi1EEkFRhIhQfEiIgyw4GM/aOVUuP8uUgrMi9MPWo9dNgfHo1oLdKb4bnpjfSiRCuRXobKi/TjAcm8junl8XiINlpElBjT+xe8kSGMICJtc5s6oD8ev6JkaDSt9BBAGFccjs+IETUcqBm+6f739++QvrApmKlj+HjQzrRzhYhummE4ikTnduU+11ruznMvvCBOR3Q3KCBDiKHvOum6Xrq+k1vbTsvidfLBgilUMHXo9/eTCxbcb/fkfAnLOx3qf37uXvDAfXNJBhLGx/v9Hs0zYuTff/8L1nFCDrLf9L///id2hAOttV8Pp3yu/vYaSYYnxsd//0sEDL52g+EsNzt3PI6v3uzZ6abpUwWPcJabvxzHE5v4gLPczC33hupz3jiOYo5BZKkyr5yLf/7Z95tvDmmqotq/JPs3DOfv0/ZtnN2bmnO3QcHnkPO30X4Nxfn7ln0aa7cm59w9ifNXv/cb7dPn77//l+iYc4b7g08V3NtZjmP7zuu4p/P6/bXwD6MAAAAAAAA4Ea9De2JkgqjDe/wsX9YPGPz33/+bpnOjASwty4YOon6vc//X9nZzbnzNYYL7zz3Zp9YvP6/zc/+Z+s+G5VPHK5L4YnMjcru1UUPZtX5+hn24X5x+u9+CkIA/kkHbtmOVhn7a7qgF8+O4jhr6iovI9C3/uX/a7ZjvjgqQW0fbgME93dlfgs7+02gCehz1wBklIVencdSD1hvtQIlWOvFceyMYaKXHoEM80sFcp3nAAmVElDHG9P0wioB9DKeH52botJ0oY5d5072R3hudoB+W9UO4YOs3+/fTiAImGJHAqZ/z7fd/f38lOcrB+LxNjDDw9+9f53nvbS/8pv0hGGDkj7dOKiAQHEcmeGD6OETghQX6fnjHMGZ6EUyPmU7yNsjQts1qWbs9N/xwv8Uv6vDxz58/3huLDSOkO+sPZe73m3RdJ1o3zvbmsu6bV3Z5NC9efrvfnOuml1t7C7btr+9uN5p26+Osf65vON7i63/9eVm9NZfKK39F9Z6wamtebcWvrM6TVmWtq6w0BvWdvOpqXF2FkVbXiaymttVUFNvUc0KrqGkVlcTz6jixR9Zy/pYqAAAAAAAAAEAqOxDPWhjpIFHs9+/v1Cn+drtNy1Lf0j8/OPtYmK9E5O/fv3Nf57H/87SfjNv95vWVXit//7lL3419cm83P+AQ1m+cpZtGTG+kbRsvIDAFJeyqdrQA2+Hd+UZ+2xFfSTACwFjm5+cnGF0gCBgE23dHMHBHKnBHHBClpGn0dETDKAlzsCF8bJtmOqb2dvO2E27TDRpMx6bsNubyurGd/+MghA5GN3ADBm5oYJ6OQwXDo7++t0yUHzBwO+z3phc72kDYWb7ruky4YA4U6EZ7IYPH78PprB9vM9mp3w0zJOblO/MPgQQ9jsJgbKfxaTp8LmNn9OG47IsgFUaYQgljB/vcv1uwbhhISIcRhg75t/uw7p8/f6ZwwBQGGAMBbkJnXibT8YZhhfTyOcgwBxeG/7ZMd904kkUuIOBOjwEDt5N+2Gl/er6lTFDQzrOjWHhFom0uLzD5RSJi9/Gb2xgAAAAAAMBlpW9AP989+uk1DuuB/dyGX6rGIXWnzfdb4biNl1D3tT8avaeOAMen0SoJNMoJcVJdtEaABjkxTq5FSzhojIvgRNMCIxriYq59wsOjH74Ad63U89s9bqX9N1rCva5XN1xO3Z/fOHV/z3B/1OmDGu1nadkww13W3tqoj/D66JgbwwoybD/Vb/jv37/y6B7Stm0ytBCPgjBM6EZHoYDc9M/PP+mgQ2aeEiU/P+4XeXuJiuCoh07tQ0d+iQID3vaVSDOOQiAyf1m4GyZw99E47a9E5OaWt0GBsVwyoKDUOOrCyMg8UkIiSKC1nrbbZEZJ0FpHYYkpmODMm7brzNONHs7zwugLqdEJlFLjCAbbymqlpVVKTSGDiRbRRs8d8QM2ndAbI0oZMWboyK+1Fq8TvbOd+Vvlh4BB3/dRebeT/RBK+J2CBXoKJdjgwhxWGEY0GJ7//v0d9qndMIEbKrBXhdNR3fTT8BFaaTGNE0BQIsaoqHP/v//+O31Dftf30jZN0PE/CAKIeHVxAwa3+z1qB8ltJwgb3O93b97/nggl3G93MWLkz//+iA0B2LDA0uP9fpc/f/5I29o2tNdJ+tGue7vdgjdaE07658V9nikTvcH7K0v8LDUjXmD/sLYWNgAAAAAAYG+vdfY89pfWw38lLuJ3btpwHxW3YzFtKHJkZWjDgrf8hfY7NmCwVVEXztfQCkIjfASNfPkWuHwDfNp1G/y6Ry4XP/hvumbDX/Oo5cIHXor9T0Cb7Jj9+Xp8fA9FXMu04364L7oP2nE/3B/dYjlgkOrfOjxZKts2rdffdgggbTu4LaWatp0qZevWtM2mfrH2mVJqHN3WpEs5T5pGT18wnuZHBYa6DHWznf9ztWmdY5FMea+sFzYQEaXkPvVLtm0ucrMBAKecnbZ9vcWYIVQwBgPCEQXc8MDt1iZHJJin53BBu1RWKbEjHzRN463bts7zsFwQONBaT8tzAYH4n57PWDA/VV6UkWw0xnb+V3YUgDFpMI0S0Peip2kt7qgE7ogIWg3b+X38itaNKGVEjO3EP5QdmseIUW7IQMn9fh868S8GEtb+STSvdQIJxhj5+/u7aVu207/9BvtmPDHNeLH1fT+nX5QSZYwYNYQT/vnnnymQ0GgtXof/cf3oMTNtAwnJMk6AIAoU3O/eczF+maWAwM/9HtRvDg5M24rqPwyL4paZ3gqyAYLlMu6bbXY74i1IPItnzH9IW1kvOxMAAAAAgP207fDNG8X9ClpchZaUVdmyajMqslI5ZVW2rNpIgRVaU1aFi6rNhytTRsAgp6gzc7hLHe2lDjbnWo1wmaO9zIFucZ3GuMSRXuIgn3WNRjn9UZ7+AN9x/sY59RFWenBt25Rb9WIrllJeZYurUXEVWlNehYurUXEV2qKsShdVm6/cH32/X+vQJ9mZ50zPI5w816fVnTGHCoK6JCaW6j11/nf69qaO1Yjf+X+tfGvvMwd1uUf9jp2yIzeecP/58fpse0GBYFQDOwKBUnoYKcCbPzwqd74Sud3ucTk7ioHzaDv6a92IGtvCzgvLiihpm8YJCqTLDkEBSY9OYEc+kHGf7qgFiX/Ddauy5YYRIdzn4o1eMBy6vzym5oBBvpB7GucL1m54CCEYGUYxEBkuJqdTvsj8PFiWGvXAff77+xCtVDQigRdKED+Y8HPXUyDB9EbUuD2J6iD+/MQ/O0pC27qBhPl4/G2KNE6H/zk8MK7T96K1EmMaZ77yppUx0otMwYSfn59xlIjx3NgX2Tgt7hkZl93ud+m6Tvquk67r5X6/BSEEPxDgLQseUy9u+xiGEtxt/tx/vOf2se/6qcbG/y/5BiUyvoEvvIkFG4vewF3Jnz3OzFzIILsuAADAiZXd0ch1vk9qpzuiag+o2oonneto5AQHVP0BiMhZjsJxigM6xUGc5CjkRAcicoaDqf8IRjsfSPmf+09z5ianO6IqD6jKSmed6miqPZhqK550mqOp/kCqPwARKfso2ib7XYwFKbkFX3fKo6r2oKqt+KLTHVX1B1T9AXjOdTRykgM6xUGIyJmOZHSaAzrNgZznSHY8kHTAwA8J5JZ54biF9cKAQdy9NT2/bVsJDzbXB1Zrle3r24Z9cMf/vP7BTh9gPyww1+3nfve+/NwYI/fk/WXbuX4YScD2w761t2m+O7KA+1zJ+O38tvO7yDyygDvtPG+9EMLwX2pa62bs/C9+QMENA8gYwpjWU1PAwNZyGgnB7jcIJjR6vi6aRkdhgni0gSFYcLvd/BERnFEMptDBFHzQTlBBRCs9reP987blnKEgXBAHFIZzHv3WnNqQGxSwj3aUgvmSUGNHf397QxklP//8yOPxGMMBkgggDFWKp9dDCcYYacZRCf7+/ZVmTHMYI9L3/RCNUCLKKPG/dX94bJpGur4fOuX3fRAoiIMFuYCBO29IDPnLH3akhLC887xxjuf38ZhGR5jfPNanG62l01rs+5LKBRPG6bZtx0BCl30zCffjvwkNJeJRDvzHx+Ph79/Zvv1/KVDgT64991YWEf+PZbk32syTLYsBAABOp7194I9s1X6uqrbih6JVAtU3SPUHsDtaxHGKxjjFQeyKFhmdqiFOdTBvozUkaoRbdljr5fWOVdeZqqa2X6loHa1TRy3lixWto4XqqKV8uaL77bxpd7hnVM1Jc1VZ6Y+gZTKqbpiqK38oWiah+kap/gAOQasknKZRTnMgu6FFHKdrjNMd0NtokdHYELf7zesHO/ebHfrwOkUX+qmGfV39eUOf2Li/q91+olpPa8f+07YzvzHG/3KZoGOt7atr+l76sGyyQkPwoOu68dv6VTok4ExPx5dZbqftN/fb40iHBfz1GnedthVnBadew3/tVI8h8JAoNIcIpk78/ggHzThChR2FIB7pYA4S3O+3YLlfVik1tY3tr9+2N/cQRGQeccAdqWBYR0vbppb55Wy72v2G+8w92nWUUuqluz82RZEKHqw9+uEAcTrYxx36b7eb36Hfbmvs0J7cTh9sJxFGcEdUECNilBGtlWjVSjN29ldi5sCEEwKQhXBA2zTe86UAQi6U4NdvNE3bY3fnpZd7b26psmHQ4HZLlv19PIbLZSwvakg6/fvvv9J3nWjd2K3M23PWd+ff73dvvgnKLb8Rb1snfqP2n+waMgAAYIN2jz+2Ia26H8zVVbgatOzBqm3gaiteLFr0QNU3bvUHUBxa9CCnadjTHMjX0ZI7jGDwViN+9wzU3cf3e7Wvu91228hbe0798bho1bxZVlPRqtHKH1BlI1dZ6arQwgertoGrrXg1aOGDnKJhT3EQxaJ1D3CqRj3VwRTlqi1rO/+bsU9yON22wQgHVqpPa2Z+ch8iIrZjf/At/q8+t18yfrP9dFcoEdFen6Z55IHpm/5tp/hxP7fbbZqe6hCEDbxv+E/Wd36WDwOooKgKQgvz2vZLEPyv1h/mh6MVtG07nR1jhlEo4hBAMCqBUuPoC/FoBe4ICEPd1DTagXIOzoYUwlEF5ul5FAE3rBDOn8+Nig7YjmowHHLi0cSNFI5gYBnlNLOISN/3Qd/wROdqZ17X9WMjzx3/cyMSuIGAZ5c/Ho8oSND1nbPOfLLnzv+99L0RY3oxvZF+fNRNOmzw+/sbBwCi4INI7+xXjEhv+mHkBpnrNnfSN34dbWf9RLhAj+mhMHzQPR5+p//cYyp4kHgcS27Y3oYyz2wv7Pw/7SOaSFr94bUSCti8vSfq8/v7u7qfUpQ/zHklivkUVUxF8ATOWoWKO2nFVQgrOGOVKfaEFVsxJHC2KlL8ySq+ghhxpipRzYmqpqKXdsaz9PK9w/WbrG/bbUuLG9pnL7teGzXV9wN13XVLBbXtreIvpDjje+FlFHfyiqsQNuLMVarYE1dsxbCAs1ah4k9a8RVEgDNWmWpOWDUVhZznbE1fgm77G5vct/mHPa7Tlhcftw1/VAEnFBAEBKZVN06nggOr02EgILv9uZxdf/qW/cRht03rr2NDCW0z958W44wGoIJHEa20GBHRQ0JAtB47/Tsd+cMO/SLzffQ4VNB6oYM5YDBUSDe20/+wfA4PiIShAXugtp//sLwJRi/wAwFeWCHxfG4+JbqZj8ddln4uopSe55pBeFoWgwbTMtvpPrGOO/14PKL1p477Yvus+9u0gQFjzBwayEw3TTN1/J4CD254ITP9++uGGPL/7DAiUyghDBGIkb7r407/znTfd9J3/Rh2mEMGqRENuq5bCRQsBAu2hA7GAk3bzG2/ts7LjyKPR9wpPx06MMtltpZLlOn7PrU1YBdn+eAEAMBH8QMUm3ChAABwBH7CQgd/OABCvE8AAPAl/BCGiHAhAADwHfwEvo4974+6HdIH8bfMj3PfLmfrba/V9Df/HzE9/Ne2w7f1R0EBb/qJ4ML4X2M7wc/dyOfRFJyO/e4+lLLr+YECpbVTZljnfr+JGwZIPdqRCNx6eV8W4gQL3A79w67UGEbYNtqBvfzatp361bsjEdhryn3eZr64JLz+wtDA1lFV7WgHSjtbyAUMxmWr86IyTuggHOUg/JdeNmwkGRRwys/TQ/lhNIK447+d1/WdF2SYggF9P/4bphsnTCBuvaZQwq9f12B5GBaYAgR9GEDwgwhuR/8oYBAsT3Xkb5tmW4d/r20y9Xk3VBBs62FHZPAvnPCyeXK5P/elwEKwD/eF5C1xtvXounArAAAAAAAAl2NvWhfzB5f0zaGvK6IW+W/x+Krv10AWKvH92h1dg3bljwrfbwHgBYdfuLwyUB+uWlTl4xcsrxDUg6sV1fj6xfr1CuDkmtLuiYpwX3RNofdGRQqpBfdHn5QOBGxYa1XYCTx96cZzm7HT+ZZRAnLT6fUz20qOKJAIEYRhgIV5jXb6PhszdKQPAwDeOsP8W3tb3s+4bRGR9tZ6xzCtpeLRCNxQgG60iJFxFIBhedu2c7DACT7cpnq785dDCdG/oYATePDLh+tZW0MEKd6IB0q5TTRYChlssWXdvu+ncu70/Cgyd/4fOqWnwgXuum6YQYyMHdnT4YRccOHxa9dxl8/TXmDBGPl9/MpauMAd8cBM4YexvLOtcPSC3vRDEyjn2MJO/3vP22kb09mLtjuOYPFkoGBLmVdDCfZN1S3vBwry2+nG0TgAAAAAADird25CfcP3b3MfpNA/DB3htEd2kXN4zqOSov/4uIfa3uuxj/NcwajW5ouQqxXfw9WHr3n54uOqxedx1eHjdrno8hup8XfkU78OL3JPTeTMRyacxzMoOHywh/i9/7XwQM4rm9Iv/DxyRzBIhwaG/95Z1kwjCcQd+ZMjCwRl1pbJ2I/ajs6gtZ462bsd7u308I39Rtr2lgxAiKihXZz5Q8AgaLt2DB1Mnf7n/ehGe/OaponKSLCeHWHAGCNaN9MoBUrUMKqCEy6wow74oxI4IznIUFZr7YUV4tEy5rLPzM/JBgxShd8JHeTWj4MFw2PnfDO8GyRIjnDgdeo3Y3kjqTevx6MTkaX1U9sTefz+euEFd7o3w4gHpu+lN71o3SS3YQMIbighHt3An9+0Qzih63q747hj//i87/vjAwg7zHuMnfJ3DwyslPF/CHiNlw0ULNXBCAEDAAAAAHVrMkMnfp/J/NKHHJrrBW/e57oiWuxJZvoPG9FaTzLRxMvK/UzwLWbxKbAFlw3ew+9EeA+XD97C7zJ4U6lXT7mdxo33gO1oslfwOfMVNNmL+EzxElrsBTvcJ937/uhSN+4wOLBjjiEYwWDe+tJzNa3bzM/fHIUg7OAfBRGUdoIMw39a2872jb9uZnvTZ7txQzYg4MySpm3mzv/OY9u2U3/t+TOiktYt7wYIlIpDBYkwge3A3zSNPB6PcWSBIZyg7UgDWs1hAX+0gCEwYESUHqZtgMCOUGCMSYYEwlEN9qCcjUVbfWcIg82rBh31p27oK6GDaFSBzDqPx8N7nhqJoOu69OgGYejACQvYdWy5vu/FH/VgXn/e7rzsMQUM0iMfNE0bBQ+6R5cIFqx07E9Md3332vrOCAS5EME4Z3X5Y+qUv9DJP7E8WSa41txfCKOowdOBgvV1Hk4QBgAAACjJa8M4ruOm1jestDon5Sto9m/JtDwn5Cto9m9bvLGGDzpD8x/12TF0hrZCyhNnlovglDitZ7bh7HIBnBan9uwWzjAn//SufIqbzLe8Yt2Vr5vv4z27RDT9tyXOACfl62o+BZ/+27rt5/pSd/B8t2/vm/rjouG8uEzTtE7RrWEDf3roFK+ifaee66aJ5g/f2u9uO9yXSNu00X7bpnXa20jbtl4IwH1s3FERbMd/UdG8tm29wEF2evwnItLoJhohwe34PwcV/BEMwtEMwvBBOC9JeS39lsMCBls9M6KBfez7PlrXzgvn24BBKiQgRuTRPaJwwbPT84gI4j0OgYCxLm6H/bGOpjfeyAe60dnRE8QYeXSPbHDA7vO94MA8r/P25ZaRKEiQnM7ta5x4ON/6vxYqWFv+UqBgx7ABIxgAAACgZK8Mm4iUHX49rvmO2oVx2mr0xlnjhFeLU1erJ88cJ/pQTdvQxl9E038Tnx1qRfN/2wtngJP2dZyCb+Pz75G4D7qXnS48rt9qcepq9+IZ5MRXj1N4BnxW/LY97o8aWR8xabXr90J4YMu2vBEMHH5H/swoBlEQwC/nBQcWQgPJAIEzgkAumDCNTNC6bai8qaZt09tTQ9ubfhyRwKnY0KHfPhtGELABBX+0gvBx3q6d55a3AYbUiAetOyKGEdHNHHK123OvldyoBG593L7xe45UkKKCHST39omQQbC/7Hx32VoIwRgjfddPHfzd9d3pYSQCSXTq9zv4930XBBTm6XRQwV/uzhsCCfM+veUL86bAQtRxf+95dp/r84YRJdxtzMvHqcRzP2AQdtx3y1nzC+mV0MCLQYMnQghdR8gAALCvptl36LVr+PJv0PwCfwmc5iv5wtnmArsMTvXVfPiMc4FdCqf7io476/X9HrpjW/BiWkUTbbXDX6GximZ6RnkBGjoAP4t7nvgsTvkVcR8Un8Opv7IPnH0usMvjEri696+A9P3RuG+ry+00ngsELHYDXwkTvLJuGwQl3Oo3U33jYIDWenVkgqVpf9JfNnfwn+eH4YClkQhEJA4EJB/9fbmjObgBA7uPcFmjmzFI0UyjGIj4wYEwkDCFDLxREPyRCaZ1g8CA+3w6HYl5w/y5nT+hyIBBYv/Jae+57SifKD90gB/6gxvT+wGEvs+ObmDTHsYY+f192J14nf/d/dqRErxggKS2PU/PZYfpR9RZ3x+ZYB7BIF3GH8Ugvx1vmRMa0FpH25oDDuFjvj3Cdbu+l9w7VnxxrYUNTGrmapnn9/NcXR7jdQYAWxw1pFYt+KUOeZVeHRWwXzkAACAASURBVJVWG8fj0sC6iq6SiqqK7+ASwTaFXymFVw/lOOulcuT9ivO12U5HdL6GOeMhCaGBtPCwGq2T5c7spKcWu6r8Kqm8+jgelwieU9kVU1l18T1cKnheBVdNBVVEWc5yydj7o1Ef0ZV+qDaYkO6NreJZW5ZPM1Q864V9aLVt5ABRG4MFwbymaaIO/6lyyWWJMk3bTv2UjRlDE1FoQS90/J/n6Vw5UdK0jWilRWk1btie4XH7qW3aYIENPARBAaWGsIY76oGIDRr4UvOms3bwCAVLwnCByEK04dshA1c2ZJB5PoxQ4IcPwnCB29E/NW8OKWwLDkzPvVERXnv+O33Tv6273Y/zmOnwvx4WiNfRSmcDCKshhSfKJr/xP3OVpS6//AW5+G5+2LrdgxEMMPCH5zmhxIugI2DzkrXhsM6qmA8UqNzFr6SLHz72wWWEfV3sirrY4eJYXE44xsmvrJMf3jc9fV+rgHNRQBXkrVoUcABrVdD6e3/I2l0B7Y3z4HLCMS5+ZV388HEMLisc64JX2AUPGZ/BpYXPuMCVdoFDPFLjfPO/ERk65aesf6/78vfMv7H+Wqdz27ndfiX/prDALtO2w30iOBCNMhA+ptcZvih+6IDfjMcUBgncaXf//mgC8TyltYgYrz21DoII43TbNumRB5x9D6MmqOhf6vxkz6E9ti9LhQtEVq7pkkIGoWQHdKfDvy2zNO2PZpAJHTjlw1BB9+ikH3rwPxFEEC9lszbdPTqnA3+iE79z3FHH/qVO/08ts/VZX5YNIozHMp0r/8ylZq6WyS3XjZa+6yVkwh2IyMpLYFUyNIFL+lrH8WLfpXEFXH4oC1fkoWhefBmXIMrDVXkYmhZfxOWHsh1zhaaHAMeMd4aPorlRGC5JlIkr8zA0LQrFpYnycZW+jSZEBbhMUZftV2zT+N+aL8aI3twPMN5PrrO4bvYfBXL4YvGhHo1uvNEPng0NPLNOY0cW8JbHIxbkHsNQgR4DBbpplgMKThDAH62g8cIB4XTbtF7fYXcUgnCEAjcMYAME7nx3hAJvmajgHNt6xr45SkHO6QIGoaVRDdyAgFJqWuYGDLqulymc4AQNvGlnW4/HIzlKQvRoRLq+2x4+CKaHgMHceT413Xd9vvP/SpDg2eDBs2EEt3zX2bDEdGa8h2ByY5nh2TRsyNjeqY09H2p4phwAAAAAAABQn2ZhON5n7XvP7IWt7ViB/e//PbnFnSuQ29ye5x+oEff6gXfxKro0Tj/wNl5GwJ54RZ0apxc70zvfE/v6vcQDKvH1YzrgdZ/a5JH3R5VSYmT/680bfXQ8KN00mwMDS8uUt604NBB28HfXXyujtHLawh8JQURJ0+jVcIL7OAULZOz47+3TCQ3IMHqBne8HDOIgwfyopra2o0T4YQdnZIPcKAW2DQuWCxeIbPj69ppCBqEwZGAfcyMUuOW6rpufJ0IG9vHxeDjbEMkFBLzRFabtpeYZb3t9NwcM1kcv8JcPwYP1gMDLQYIn59k23RoaWCujdSPOTqZ9dd7oBfn0wtZ9hj9E7OK+6wQAAAAAAOBMtn8zzzM+fHuxwLuZBVZJPlqrMhug1GrJR2rm/OEJ31bulYgCcHngZLikcS5c0RhxKeACuMxxHumreeiD9rn9HabQF2uh1RLujxZbrdFnarff63+urzuygO3e+myQwW6t0XpTSzSNllSn/XSQIF7mT6qx071fbnEkAqeM0sqbZ0MF8Xr+9DA6gBMQGMvb0RlWRzLQOhFC0F7QQJRI27bRvrVuvHrkRjewj9O/6Zhk+vL7EkcoWHLZgIGVChrY6dzoA3a673s/bDAtHDrg+wEDPygQBRjCZc7zvu+TwYMpJCDizJ8qkA8fLCyzozVsDSok52XWWdrOFDDYGCwY/rg1pweMuzAIFYRl3M7/z4cX/G2KBHUZ+UEGAAAAAADO6Qzfbl39za2kCo+qwipvcdLDkqqOrKKqPuMTh3WG93h8xklfZigaVx1GXAr4EC41fBdX4KVx+ouy97dMf8u5L6sKj67CKm914kOT6o6usuo+48hDe+X+aK4+Wquw26mIGCfEsHAkwSKt9dCnWJyfTQu9vW0n/Klj/1Q+fu5Pzs/tKABrAQL7RAdBArsTNYUK4rBAfpQDGzDwy9tp3ehoHa213+nfCSBMoQRn+RwsmNvYa19xRjVIrO+OUuD1ya9glIKcpXCByIaAgcg5QgZW6lBSIxrkHvu+n1644bqpEME0moExT803ZtiHPwrBlqDB9sBBHDzoEuvmpteCCfF090h1+l/u8D8nsJ4LGnS9M7pAcMqXQw16qbA3ixEMAAAAAFzV57/t+DS3Jd5DM3hojtDFW+Tih59Ds6RcsFUWDvl8Ixhc8PxiwKlHgEsCaVwZl8GpRgaXBtb5V8lx32q+vQ6XRlNEaJIcWoYmSKNZlly4dZxDj++Pbg8BWGrqoB6lCxL9YJc3qrWWfvzi67kva9zNO5wzdc4PRyhw5rnf0u919J/KBNPTeuEIBP7y3DaikQdWHrVuRA9DBiRGDphHKghHMXBHJnCXp/7Z/s42nBCGFMLH1PR01JWNVJBCwGBBdmSD3iQ67JspWOAFD4xIb/pkSGHLyAWp54+pI76ZXpzhPr3QwMbHMFiw9fHxeOQDBOKEDKbF6emu6zYFC1KhAmdvzrZTz+eO/0tBgnB/mZKLcxnBAAAAAJjx7bd5p/yF+itoycPQtLuhKfdCSx6CZt3NmZqSz3DfcaZr6Ho4e6fEaa0ap+8MOIunwamsHqcw7XvfaM8ZORTNuyua8wi06u5o0kPU3qyp+6Nb+49qpTNLF770Ot2NVbRWzogFQ1gg6ty9MMMGDMJQQVi2sSMBBIXt82nkgWm5XzYVMpg76bvBgOemlRqP34iIGkZHCEcliDv7z+s3TRNvM1jXHbFgMVQgSpSORyo4Q6DAtRYuENkYMBA5b8jAyo1skAwVLDw+Ho/peTJM4CybO/Knyg7Lhk7s/nrD9LA8ChN4dYrLiJKgbFBGxDlmW7/8vrquW+js7z8fRkhIv0NOQYoN2wmfhGVSoxdk38DHp0MSLXGJx0UnjGAAAACQd+w3oZ76V5Nr4BR+Bc3+TbR+tTh1X0PTfxtnoCpvnK59P7dz3VSJ0/YxNPWn0eLV4FR9FM29n+M6HHOWToXT+TU0fSk4E9Xi1H0dp6BEnJVqPHGqkv1GMyEAOyf6XWClvIgNDcQFldZjf10zfOO/yGKQIBcgaBbu89rQwLRaMkjghwcWRytQqU76tkww0oA34sBy2VzHf3cbc5AgXuaHF5aDBNl9BSMVnC1UYG0JF4g8ETAQOX/IwApDA3Z6a8jAfey6Lg4SONtbWuZ2lndHCYhDD3YbY5mFsMFyMEHEmD5T5rl5febb/dcCBPkyy+uFZebRBfxLNnmjZyFEkJvj7wMAAGzBN2Me5xIf0qvHWcJGXCpV4DTVhLOFBVweVeF0HeMKv6dx7ayhhb6Gpl9FE21FS30cTb7qKk30vW81L9FVzjp2x6VTFU5XjThr2IhLpUqctvc13hdj+1Phl1v7n/8zrZ/oi9o0OurzqpQWJSJd36+OKhA/98MCaqEbuI62vW10gtT0Wqgg9xiFDYLQgVbaDz0kyjRNI31vRClntIYNoQKttXMsc1DCLe8+n1r7pMEC65CAgch1QgZWeLj2+daRDfquF3dkgChEME2L2KCB7bBvjPHWd0MGYXBg19DBljJBMGFLGfuN/1vejHO9/res2/edtzi8sbM1QLBQjWE/jGAAAG9Lf1PipT5qoHZcrqfAaTwbzigKxaV5OpzSM+Ps4ss+eAl6w3PjNSd+yzjxocnZj+5QJ266vQ5t+LvUiRsK58flezqc0jPj7KISXKqnxum9As4yCrTTZemNYDCGALRW2X3kd7tcIa2HkIHt1z0HC0S8wIA3sX2ZbtyO9OsjECSnp03mgwdD5/4ngwTjY6ObeZs2BBBtW+KAgFLS9312eTgvNTJCWCYcvSCcPrOt4QKRFwIGItcLGVjhiAZrj2vLpsCBEyiYyo3zOtspP+jwn5zndOjPrrcQIngqPPDCMjsaQyIb4D2zxx8vST9LLZr2Nc5b/EPZi/tiBAPgGFf45rxSXfKH+2VxtoFFvEQuh1N+VZx5QER4KVwYpx4in70PU+41V27NDlfooRdaLSm5Zocp+JALrpqIGNE69cUq2F/ZVwJQNF4+l8bpvyrOPPAUXjIYcSmcW6O17bU6dTDv+z4/Wtn277L2ltjO8X3XJ/qyqsTUPCPfH3zoSO9+8/8039nYYtggU07r5qUQwdxxX3vbttu3xx528B/CAs1UN6311L85DCaEx+uOcuA+d6dzIxVMdb+IZ8IFIi8GDESuGzKwUmEDyx1NwBuZwJZNBAr8kQrmRFTXd4mAwrgwGRZIlzVm/Gb/zdt5YtnG0EHX+Z3+54e4h78JC0briBiT6+Cv4m2uyRRfetPvCRh8BN+iBhzo0j/J4eJSAFcBUBFersjg0gBXAVC4Ql+iRd57O7Ctjj0NhZ5k18FVpH3zi4p8rZ1BBZcFPo/LAj6uCKB6vIyxAZcJfFwRQHW++LId7tnYYEE3dHJfWiG50M6cO7i6/WKV0mJMnwwK2G/c9zadShmM/+spEGGZuc5PhgjCZblQQaozf/iolfbqbUceWFonfGyaxhtdwNZQaTW1k1IShBLSgQVbB78tUm1wHc+GC0TebKarhwysMGyQG+kgPZKBSBhAmEY2CPcxBRPsOvG62cfEul33GJcP87YHDV4rP3zjv58SMMGTKFgQvNmG86akWFDOhjxSjNl44W8otLQf7CebCMQxeGfHCXFZ4zq42gGgSLw942S4pAGr/lcD991wKfW/ZIFFXOK4Lq5+AKgSb9+4AC5zYEkZrxCttfS9Ea0XOouuVNWIRJ3YU/vxBaGC6Im/IK7f/LzRbud+PzQQdrAPAwbzuokQwVQ2XjYfT377NjBg18tN29EKlFLTYy6g4M8bR3Bwwg1h0CE+lmt6JVwgskOTETLw5cIFq49TAMBf1nXzCAZup/3cvoZ1elvYH2EgfEzUxY4ysGewwM4bRmkY500Vfy5k4L7RTtsPynid/hNXZ/qCXb+MtRr2TagAAAAAAAAAR1Bvdfau6DbtjlXd/6graMcdq/jeNYc6VHBNA8AV8faMgnF5ogxciQDwFV94+33//lRlPzN2ru4l74+K7FbN/PX34g6c1ZRSU1/aXMDAnwqfLH1BjBMwcEbODDvSp57rJ0MFbh2iERCUBKMIxKMMpOeNgYFxe03TRMvCx1SoIQ48OMfqJy0u69VwgchOrUfIIC0XAMiNZpB77Pve67hvO7i7HexTIYR02GEoNG8jHRSYRx0IAgfZfU0z4nnjdN93caBgXm2etyVQED7PBQyCXSWeJuckmfmNyAhBAwAAAAAAcLz3vl2cW3YvK6DpCqjCqJyaVKOgJluryvVGMCjo5ABArXgrxRu4fPA8rhoA2Owkb5mX62xeokKasJBqSEk1qU5BTZerin9/9MkKZ778Wo/9ud0+sVuCAm5nbqW1LPePV9Mi3Wh/3kLAwJax68x9z1OBAnd0gtz03Pk/FRxYChq4wQQ/pJAu4+4vN2/YLaEC651wgQgBg495JmzgTtuAQaqDv30MwwKLIwwkytthRcLyxvTJAELfd4n9uPWbFk7LxYh03npzeXeeN5SLu36wj+h5sM2lUQzSF6s/N3pDN/EkAQMAAAAAwDekb0Jya+aUKj2tlVZbaq45Eio/nZ+q/vaAQeUNCgBb8FZ3apzeK+KsAzihi7217f6t0qhHxae44qpL7bVHRuWn9ejqD/dHt39BtUtplVy+LVgQsh3qnQ7//iKvrBskGPah5qLJURCCUIATPIiXL5f1wgLJIEE+ZOCNhpCYnwsSpKbDcvC9Gy4Q2XH8B0IG220JG7jL8qMNBMEEpxP/1rBBbgSD3PajbfVmDg4E64cBATsawrzMKeuUz45aEK6zEEB4LmCw4c3ce/OXeB8AAAAA8CU6vHkFPOsCd3QucIij6xwpCnGRS+7Mh8nnCODizvwGVylOSek4QwA+iLecSNSJD3jXRV5nFzlMudKRomAXugzPcqir90cTX0ztTmmls8uG7W8LGMTl4tEIcvO1biQsOnxuSpXV81amL/1/brppxv0tjE6QGoEgFUKwj+4ICCJDX2B7bpIjFQTT8O0RLhDZMWAgQsjgFVvDBu5yd/5a+MB26n81VJAajcALPrid/J3pVOf7ruslegNVOj9KwUqgYI+AwaY/oCXCBSKGgAEAAACKtf2bEIADcGdgQlOEaBFgES+RCE2Ssm+r8LkRSODNZ1c0555oTeCSeOkn0dEcxeA16qE5UmgV4Gm8bJJoliWvt072/mjUZzTu97q0fHX7I6X05iBBLnTQ6EaMiKS6lC+NDLA27a+7PmKByNgumZEQbIggNzJBqg7xaAWJBoBnr3CByAEtTcjgdUuBguyoBdlyIqnQwBxISC/fvCwROMgt6/s+qq9S7igFfhjACxVM88LnqTLzvO0jGJhNIxf4k/kQBQAAQKnoOIRi8RvkJjTTs2gx4PR4mW9CM73qOi3H7wl423VeLqtoihAtAnzchV92dDZH8S78+nwVTfYKWg24FF7yL6Pp9nCeVozuj3rBgvg43X6vkimzuI+x+Pw7jAqCAXGIwB09IFfGrZ/d3tzPfN6HNyqB7dTvjk6gmyFAYIME0zI1de4Pt+8en9u3PQw3rI1g4B+HNx5DMjyB2J7hApGDohyEDN6XCxBsexTJBwTmd8Cu76bpbFggNe+N8n3Xex31vREL5tnpN+iN85Md/838hrWWGkstTq1DwAAAUDM6kaBY/CaxC5pxb7QogALx1nQImvVItG6J+N2wUCd7uZzscOSMRwQsOuElf8JDGp33yLao4nPNtU/R7mjOo9CyACrCW9ahaN5PoJW/Lez8n+ufqrSO5z+zj3HbWoVhAZF8YCA/Xzsh6/Cb/t+aFiW6WQsGaKfDv4qmV4MFiVEQUv3id+4rf3p7hwtEDhwrgpDBvnIjF6yFDdLLRFIBBLfDfCqQ8FSoIDXPDTVEBxi/ORtjkvPddZy9TbPd45h+AHhlM9tb3H68DgEDAGdTxc13nBOfGg9HE38KLQ0Ah+Et9uNo8m+h5fFZ3AsYFfrSK7Rao7Jrh4rtfGnxreb4ON4eP4am/jRaHAC+irfhr6HpS8BZwDHcvqVRH1UbCHjzvoINF0yjANgF2c3OoYJUf3Gtwi/ZtnWMO/pPz4IAgd231joxQkEcCJjKZrZjy7pBgaXHcLvGGFFKTY943hHhApEDAwYWQYP9pEID7vQzIYMwMBB2lh/CC2NBb/2t87buZ17XXzCvl5r/1GV1QLhAhIABgHPavWMBnwI+iub+FloeALADfpx8FM1dGs4I8C3FBgw+8LbwuXce3uOq9aFT99kr5JrX40vvdddsqiLQ9KXgTAAADsCPl+JwSkrG2QGO5o4s4HYYNWJ2u2+6tp24X3h61IKl7UwjBnid/p8IGUSBgjhs4O0n2JbSytvmWqggN43XHBUuEPlAwECEkMERng8biIQhgLCcOyJCtE5vohEMvOnECAep5bZTfhQsCAMFiYBBuI4xQ/rKO9ZcMOEAVwwYFPsHR+yLd+yvovm/idYHACCLH5NF4rR8E60P4Bx2ud/34lvie++k778P88erk+BHcjE4FaXgTAAAsDt+vFaB01QKzgSAeny2L6Tf4T83LxwZIK5jHEBwy6RGFojKpIIEw5AJ0YgNdnthSMDdZiowsDYv3R54xpHBgmkfR+/ARdDgGGGzhs/nTv3LoYSpw3zQST8ZSPACB+NK0XRmH2thgifDBu7rxM4f6pey8RJMFUu8Wq54SfOHN0yud/kDm/HyACxeDQAAAEDJuNcHbMCvtkASLw0gh1cHAAAAUAOlhi+3ju6Rhh/pX7yFqpQSMSJKK5mCAYvbm8MDqRBAsryKQwhhyGAqp/Q8yoCMgYFp1AEdhx0ygYJof8kAQSqUQKhgL58IF4h8OGAgQsjgaKkRCNaCBbasMf3GsvkRENbK912fCAusj1SwFCYIt7NpZAHjPUjq2RKllJieSxkAAAAAAKAESl/wrvROt6b2u8PFvbJiPHEqLvnaAYCr4Ud0NThVZ8MZBQAAx7n8l0ZwbxRLNp6Oo+6NDsGFoSLLoyTEoxEopRIBgXRZO19rf53h/SExOkLQ4d99nhpxwGp0E2xbsmWjUIHyohV406eCBdP+Prkzi5DBZ+Q6+dvnXsf/3sjWUQjWpsNtu8vCzv9+YCA/aoEXJlhaFh5bFCR44dIbVwl/oGwKMgAAAAAAgLdo9Zkhaj97s4pbY6jAhy/Tz78qeB2KfO499iq4qj6FlgYAAJXj40wxOBWfQktvpbX+aHNxPwZY8IXLldfkZ+XecxM9X9PrK73aL1WN91/T4QB/W+HybNAgmJcKMdgRCXLBAbtObnmqbK5cqs/75UNQB/h0uEDkSwEDi6DB57gjDWyZt2na6ei/FEpIhxuG8tEQM6vhgfB5OpTwUud/L4ww/D+9OSaWcfkCACL8aAAA4Cl8azKKVthnu8KqIyXWCMBGzsuXn8UA8EF8fFpFE72KlgOA0tHJDtUp7ONFYdUZlVkrANu99fM586XV4Rdi68X7r8r5X0Rp7YUHvI78XthgDhnYMrYv69qoBG5YYEu4YCl04O4zVQb7+Ua4QOTLAQMRQgbfkOrwH85/N3yQCxxMHf+DIEG4Tq6uW9fLBgw2jGiwJVm2uA8AAAAAK8M9fkAlv2lWUk2pqaYAsIsK3/bqqXI9Nb2Cr39m2+JCl8yFDnV0vSMGAFzYhX7sXeVQlzuLfUhFjV1RVUf11RgAdlfhW2GFVR7VW/Oapb982p/Keaa/99I92GE78agEqdEL4n2qaZSCpU7+uREHngkVpNbJ1RP7+VawYNr/N3fuImjwebmgQW46v1xkDhMsT+c65aeCCantzzPjoIFb1vTeWANeGfcHwzM/FObyjGAAAACujdQ5gGqd5Ne4kxyGnOlIAKBWfLYH8FWVfxysvPpyhiMAjsDnIwCnc6If+fUfSv1HAABnsumzvxc+MC99YUtqP2EoYJqf7LDvBhDiMEJuVIJwP9kQgbPPeb6/H3/dYTmO9e1wgUhhZ5mQwfflQgTu82QYIOjwn9uODRgkQwMr6y6vMy/bMrLA6msvCBOkMIIBAOBsqvjmyrM60afgEx3K6HxHBABAkU70I/dEh7LiOkd6Zpf6PbCQS7aQakhJNQGA3RX2FldYdUZl1qoUWuU/I52v5c53RAAAVOkiP5LPeZjnPKoriL+oej6Xe/bttvsxZmkUrHyHfvt86EurRCs/hJAbBWEteLA0nQtF4HglBAusYiriImjwXbnmf25Ug3Q4IeqUnx2JIFEHp+ziJZIaacCIqNybc6YOa9vmMgVQk4I+ewAAcB4n/JXghIe04FpHCwBACvcLgBUf+Mh4/C7O+7mX9zAAAD7gvB8lks59uOc+OgAAnpW6r+B+0fVeX86y1Gk/nh8HBeZyOrksrGdqdIQwRLA1QJAeUQFHKSlcIFLwqSdkUIbUaViatxYysP9e2U9qBIO1/W1+vW0YsSDECAYAalP1txJe4FPBuQ/x3EcHAACADD4GnrwJzn10V3HFewXvXblc9yjcG5fo+1f3d14f1b2Pnfxt5OSHJ1c4QgAAAHzRyT9unvzw5ApHeDZa6/jLqZe+yHrobm8nNzFGplBA3Jc1HSYIO/XnAgG2rK3vFGRIhALckIPbr5ZQQRlKCxZYRVbKRdCgLLmRCbaGBtxO+e5y9/WR28ezz5cunT0uKy5NlKTQnzEAAKAkF/74et5DP++RAQCAz+CeEgAAAC7j5LfSzn145z46AADwHfbeqP3i61fvlYajA4ShhaWO/952EsGCcPupfWqtp76sUV1WpnPbx+eUGi4QqSBgYBE0KM9aR393XrTMeRN139y2jWSQ35a1eXSBF0YuAICi8XYGoAC8FQH4Pt6JAADYIvu3i8yP0oWvdHl9XwDwKfyaAODkeJsDcG68ywEA9vX+/cphRAN3xAMbVnBppVd7arvhAqVUHDbIhA+8bawEB7znStXTefykSg4WWMVXMETQoExbRzBw5z0TUHhl3uaQwbQRP2yglJbFP5lxKQIAAAAAUL0K7t/t58VbGe/dAeH+CVCyS70HAiU42Y/Fkx1OxjWOEgAAAOd32XsA3BMFkPHO++LaF7fYfqha603bC8ttCRDM85TkqrM0cgG+o4ZggVVNRUMEDcqVOzXGmNVO+e+FDETcD2jGmOToBilLr9lUqixXBwAAAAC4koruf+DqdvwVfv+7AdxfAPA9/CwHgC8p+CNgwVWT0msHADgnfm9CtXb+6HTMJzE+3wH4nnd/xm9Zf61MKoAQjlawtJ21AIEaFqzWE8erKVhgVVfhEEGD8i2NWuCXEwk/OC6FFZa2sbY8Zcvr112fSw8AAADvqvB3SAAowwd+Jf/Mb/3cWwDwXXweBQAU68Mflcv4ZF5GLYC98FkTAA520EeHz30i4bMPgO/a+nl1r5EOwu2kggRh2bV9J5crVX/H8BOpMVhgVVvxEEGDerwyioE7EsGWU+2OlvBscGCLtSADAAA4XsWfwQEAwNV84fbB8bvknghwBvxeBQA4peI72y1viZ/PAADglL54O/HYXXOfFKjV0u9ee/1eppSatmWMSY8ysKEeSyMY5LaL76o5WGBVfwAhggZ1WR7RYPvoBWvbWX2tOgGGZ/R9//Q6AABgPyf4PA4AAIBvKuROIn/kxLcoFQ/B7eP6AVCTve4T8d4HAAAAAEf+asT9UJRguDeav16ynfoXRh4IhX1Xl4ICW/btFDhf5++TOEOwwDrNgYQIGtTrpREOFpYfeSn0PZcZgLrpzGea/d/deL8EAAAAAFxUwb8S1cEjCwAAA/dJREFUK134nwgybZf5apoDKwKgCAsvc7tIK3XQuwHvMQAAAAAAfNXOv5orrYZt7nyLdGuIYKlsUOi8Hb1P5EzBAut0BxQiaFC/Ladw71DBvL6THnMLfPKVc/AV/JkXCC9DAAAAAAAAoDQf+ZvHB24Nco8TAAAAAAAAwDO8e6MmNWnicv4WZMs9w6V7sMnQwbBgdbsowxmDBdZpDyxE0OBc3h3l4NWyIvObOpcUAAAAAAAAAAAAAAAAAADAub3Sj3x9HUWWoFJnDhZYpz/AEEGD63gmhLD0Wl/aDpcTAADAOV3gd0EAAIDPWLh9tmHc0h0rghQ+9wIAAAAAAABv2uE2JvdKP2/LvdF37p8qpUSMmc4c92LP4QrBAusyBxoiaHANR59mLiMAAIDzutDvhd/xxkfphQjw6xsFAAC4ID7zAhdmlp7yu5UI75EAgAMlftRyzxMAAOCzjv69n/sK53GlUIHrkgcdImwAi0sBAAAAAAAAAAAAAAAAAAAA1tDFnC7XV3HVUIHr8g0QImyAZ3HJAAAAAAAAAKiRUor7mwAAAAAAAAAuh/7jCBEq8NEYCwgbAAAAAAAAAAAAAAAAAAAAAMD5ECxIo1E2ImwAAAAAAAAAAAAAAAAAAAAAAPUiVLCOBnoBYQMAAAAAAAAAAAAAAAAAAAAAKB+hgufQWG8gaAAAAAAAAAAAAAAAAAAAAAAAZSFU8DoabieEDQAAAAAAAAAAAAAAAAAAAADgOwgV7INGPABhAwAAAAAAAAAAAAAAAAAAAAA4FqGC/dGgByNsAAAAAAAAAAAAAAAAAAAAAAD7IVhwHBr2gwgbAAAAAAAAAAAAAAAAAAAAAMBzCBR8Dg39RQQOAAAAAAAAAAAAAAAAAAAAAMBHoOB7aPjCEDoAAAAAAAAAAAAAAAAAAAAAcCUECsrBiSgcgQMAAAAAAAAAAAAAAAAAAAAAZ0GYoGycnMoQOAAAAAAAAAAAAAAAAAAAAABQCwIFdeFknQChAwAAAAAAAAAAAAAAAAAAAAAlIFBQN07eCRE4AAAAAAAAAAAAAAAAAAAAAPAJBArOhZN5AQQOAAAAAAAAAAAAAAAAAAAAALyLMMH5cYIvitABAAAAAAAAAAAAAAAAAAAAgBzCBNfESUcSAQQAAAAAAAAAAAAAAAAAAADg3AgRIMQFgacRPgAAAAAAAAAAAAAAAAAAAADKR4AAz+KCwe4IIAAAAAAAAAAAAAAAAAAAAACfQYgAe+JiwkcRPgAAAAAAAAAAAAAAAAAAAAC2I0CAT+JiQ7EIIwAAAAAAAAAAAAAAAAAAAOCMCA2gVFyYuCTCCwAAAAAAAAAAAAAAAAAAAFhCCABX9P8BYjgu2dCVOSMAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M524.93,362.33c4.02,6.3,6.17,13.77,6.17,21.43v34.67c0,7.66-2.15,15.13-6.17,21.43l-6,9.4v-96.32l6,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M524.93,362.33c4.02,6.3,6.17,13.77,6.17,21.43v34.67c0,7.66-2.15,15.13-6.17,21.43l-6,9.4v-96.32l6,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M521.18,343.85h0v114.5h0c-3.04,0-5.5-2.47-5.5-5.5v-103.5c0-3.04,2.47-5.5,5.5-5.5Z",
    transform: "translate(1036.86 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M458.8,315.09l4.39-6.29h48.83l4.39,6.29c1.64,2.35,2.54,5.28,2.54,8.3v155.42c0,3.01-.89,5.94-2.54,8.3l-4.39,6.29h-48.83l-4.39-6.29c-1.64-2.35-2.54-5.28-2.54-8.3v-155.42c0-3.02.89-5.94,2.54-8.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 463.19,
    y: 308.8,
    width: 48.83,
    height: 184.59,
    transform: "translate(975.2 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 463.19,
    y: 492.08,
    width: 5.86,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 463.19,
    y: 489.31,
    width: 5.86,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 463.19,
    y: 486,
    width: 5.86,
    height: 1.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 463.19,
    y: 481.97,
    width: 5.86,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 463.19,
    y: 477.26,
    width: 5.86,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 463.19,
    y: 472.09,
    width: 5.86,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 463.19,
    y: 466.3,
    width: 5.86,
    height: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 463.19,
    y: 460.14,
    width: 5.86,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 463.19,
    y: 453.37,
    width: 5.86,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 463.19,
    y: 446.29,
    width: 5.86,
    height: 4.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 463.19,
    y: 438.78,
    width: 5.86,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 463.19,
    y: 430.98,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 463.19,
    y: 422.97,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 463.19,
    y: 414.74,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 463.19,
    y: 406.52,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 463.19,
    y: 308.8,
    width: 5.86,
    height: 1.31,
    transform: "translate(932.23 618.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 463.19,
    y: 311.18,
    width: 5.86,
    height: 1.71,
    transform: "translate(932.23 624.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 463.19,
    y: 314.23,
    width: 5.86,
    height: 1.96,
    transform: "translate(932.23 630.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 463.19,
    y: 317.85,
    width: 5.86,
    height: 2.38,
    transform: "translate(932.23 638.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 463.19,
    y: 322.14,
    width: 5.86,
    height: 2.79,
    transform: "translate(932.23 647.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 463.19,
    y: 327.05,
    width: 5.86,
    height: 3.05,
    transform: "translate(932.23 657.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 463.19,
    y: 332.43,
    width: 5.86,
    height: 3.46,
    transform: "translate(932.23 668.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 463.19,
    y: 338.38,
    width: 5.86,
    height: 3.67,
    transform: "translate(932.23 680.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 463.19,
    y: 344.94,
    width: 5.86,
    height: 3.88,
    transform: "translate(932.23 693.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 463.19,
    y: 351.72,
    width: 5.86,
    height: 4.19,
    transform: "translate(932.23 707.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 463.19,
    y: 359.07,
    width: 5.86,
    height: 4.34,
    transform: "translate(932.23 722.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 463.19,
    y: 366.58,
    width: 5.86,
    height: 4.63,
    transform: "translate(932.23 737.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 463.19,
    y: 374.6,
    width: 5.86,
    height: 4.63,
    transform: "translate(932.23 753.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 463.19,
    y: 382.61,
    width: 5.86,
    height: 4.83,
    transform: "translate(932.23 770.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 463.19,
    y: 390.84,
    width: 5.86,
    height: 4.83,
    transform: "translate(932.23 786.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 463.19,
    y: 398.72,
    width: 5.86,
    height: 4.76,
    transform: "translate(932.23 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 506.16,
    y: 492.08,
    width: 5.86,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 506.16,
    y: 489.31,
    width: 5.86,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 506.16,
    y: 486,
    width: 5.86,
    height: 1.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 506.16,
    y: 481.97,
    width: 5.86,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 506.16,
    y: 477.26,
    width: 5.86,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 506.16,
    y: 472.09,
    width: 5.86,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 506.16,
    y: 466.3,
    width: 5.86,
    height: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 506.16,
    y: 460.14,
    width: 5.86,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 506.16,
    y: 453.37,
    width: 5.86,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 506.16,
    y: 446.29,
    width: 5.86,
    height: 4.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 506.16,
    y: 438.78,
    width: 5.86,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 506.16,
    y: 430.98,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 506.16,
    y: 422.97,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 506.16,
    y: 414.74,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 506.16,
    y: 406.52,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 506.16,
    y: 308.8,
    width: 5.86,
    height: 1.31,
    transform: "translate(1018.17 618.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 506.16,
    y: 311.18,
    width: 5.86,
    height: 1.71,
    transform: "translate(1018.17 624.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 506.16,
    y: 314.23,
    width: 5.86,
    height: 1.96,
    transform: "translate(1018.17 630.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 506.16,
    y: 317.85,
    width: 5.86,
    height: 2.38,
    transform: "translate(1018.17 638.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 506.16,
    y: 322.14,
    width: 5.86,
    height: 2.79,
    transform: "translate(1018.17 647.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 506.16,
    y: 327.05,
    width: 5.86,
    height: 3.05,
    transform: "translate(1018.17 657.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 506.16,
    y: 332.43,
    width: 5.86,
    height: 3.46,
    transform: "translate(1018.17 668.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 506.16,
    y: 338.38,
    width: 5.86,
    height: 3.67,
    transform: "translate(1018.17 680.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 506.16,
    y: 344.94,
    width: 5.86,
    height: 3.88,
    transform: "translate(1018.17 693.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 506.16,
    y: 351.72,
    width: 5.86,
    height: 4.19,
    transform: "translate(1018.17 707.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 506.16,
    y: 359.07,
    width: 5.86,
    height: 4.34,
    transform: "translate(1018.17 722.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 506.16,
    y: 366.58,
    width: 5.86,
    height: 4.63,
    transform: "translate(1018.17 737.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 506.16,
    y: 374.6,
    width: 5.86,
    height: 4.63,
    transform: "translate(1018.17 753.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 506.16,
    y: 382.61,
    width: 5.86,
    height: 4.83,
    transform: "translate(1018.17 770.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 506.16,
    y: 390.84,
    width: 5.86,
    height: 4.83,
    transform: "translate(1018.17 786.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 506.16,
    y: 398.72,
    width: 5.86,
    height: 4.76,
    transform: "translate(1018.17 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 468.02,
    y: 308.8,
    width: 39.17,
    height: 184.59,
    transform: "translate(975.2 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M499.67,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M490.21,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M480.76,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M471.3,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M529.81,505.71c-.4,0-.8,0-1.2-.01-1.1-.03-1.98-.94-1.95-2.04.02-1.1.93-1.9,2.04-1.95,14.41.3,22.48-5.62,30.31-11.36,6.51-4.77,12.66-9.28,21.69-9.85,7.28-.48,11.62,2.91,15.11,5.62,2.76,2.14,4.42,3.34,6.47,2.92,3.09-.62,3.27-3.4,2.52-9.79-.5-4.31-1.13-9.67,3.57-10.39,4.27-.68,6.5,3.43,8.63,7.39,2.47,4.57,4.44,7.82,7.97,7.72.99-.02,1.36-.32,1.55-.54,1.09-1.25.68-4.94.34-7.91-.51-4.55-1.15-10.22,3.71-10.88,4.66-.65,7.01,4.69,9.28,9.85,1.66,3.77,3.73,8.47,6.06,8.52.37-.01.5-.1.57-.17,1.06-1.06.99-5.26.94-8.32-.09-5.25-.19-11.19,4.55-11.34.05,0,.1,0,.15,0,4.68,0,7.01,6.57,9.07,12.38.6,1.68,1.43,4.02,2.1,5.3.67-1.47,1.45-4.25,2.02-6.25,1.86-6.61,3.63-12.86,7.9-12.86h.03c4.15.03,4.54,5.27,4.95,10.82.29,3.87.72,9.73,2.72,9.78h.03c2.06,0,3.67-5.09,4.84-8.81,1.67-5.29,3.54-11.27,8.42-10.31,4.74.94,5.3,6.57,5.8,11.54.32,3.17.71,7.11,2.19,7.74,1.32.56,2.97-.83,5.53-3.2,2.94-2.73,6.6-6.12,11.45-5.5,4.14.52,6.28,2.17,8.54,3.93,4.83,3.75,11.47,8.88,47.1,7.28,1.16-.08,2.04.8,2.09,1.91.05,1.1-.8,2.03-1.91,2.08-37.13,1.67-44.41-3.99-49.73-8.12-2.05-1.59-3.53-2.73-6.58-3.12-2.98-.37-5.67,2.08-8.23,4.47-2.82,2.62-6.02,5.59-9.83,3.95-3.64-1.56-4.12-6.37-4.59-11.02-.36-3.59-.77-7.65-2.6-8.02-1.34-.29-2.89,4.66-3.82,7.59-1.74,5.5-3.74,11.75-8.78,11.6-5.62-.14-6.17-7.54-6.61-13.48-.17-2.3-.45-6.07-1.1-7.06-1.37.78-3.1,6.9-3.94,9.89-1.67,5.93-2.78,9.87-5.79,9.87h-.05c-2.83-.04-4.12-3.65-5.89-8.66-1.21-3.4-3.45-9.71-5.31-9.71h-.02c-.78.63-.71,4.95-.67,7.27.08,4.61.15,8.97-2.12,11.23-.91.91-2.06,1.33-3.49,1.33-4.86-.12-7.28-5.61-9.62-10.91-1.52-3.44-3.45-7.65-5.09-7.5-.99.13-.54,4.1-.27,6.47.46,4.13.94,8.4-1.3,10.98-1.06,1.22-2.56,1.86-4.46,1.91-6.19.23-9.19-5.37-11.59-9.81-1.82-3.36-3.1-5.58-4.51-5.34-.89.14-.48,3.65-.21,5.98.59,5.07,1.49,12.73-5.7,14.18-3.94.78-6.88-1.49-9.71-3.68-3.26-2.53-6.62-5.14-12.41-4.79-7.86.5-13.29,4.49-19.58,9.09-7.78,5.7-16.57,12.14-31.56,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M958.81,509.19l-27.97-22.56c-2.73-2.2-6.62-2.2-9.35,0l-27.97,22.56h-33.9c-6.33,0-11.46,5.13-11.46,11.46v11.69h147.25v-11.69c0-6.33-5.13-11.46-11.46-11.46h-25.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M932.92,513.27l19.11-20.59h-50.39l19.11,20.59c3.28,3.54,8.88,3.54,12.17,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "996.09 496.16 864.01 496.16 864.01 484.97 957.64 484.97 996.09 491.94 996.09 496.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 880.55,
    y: 484.97,
    width: 77.09,
    height: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M932.91,506.37c0,3.36-2.72,6.08-6.08,6.08s-6.08-2.72-6.08-6.08,2.72-6.08,6.08-6.08,6.08,2.72,6.08,6.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 1302.62,
    y: 473.88,
    width: 1783.93,
    height: 92.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M767.11,457.44v32.86h372.22c31.92,0,63.73,3.82,94.74,11.38l116.64,28.43c29.5,7.19,59.75,10.82,90.11,10.82h1645.73v-83.49H767.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M723.03,518.59l-27.09-21.79h-307.63v-48.27c0-13.61-11.03-24.64-24.64-24.64H62.14v167.59h61.44c14.98,0,29.61,3,42.31,8.66,16.52,7.38,35.51,11.27,54.92,11.27h99.68c8.66,0,17.34-.82,25.76-2.37,7.53,6.08,15.39,10.05,23.09,10.05h166.1c13.48,0,23.04-3.25,34.11-7.01,13.11-4.46,81.45-7.26,81.45-7.26h253.64c4.84,0,9.69-1.17,13.69-3.89,3.73-2.53,8.13-3.88,12.63-3.88h256.42v-45.15c0-2.01-1.09-3.85-2.84-4.83h0c-33.67-18.68-98.95-28.49-137.46-28.49h-324.04ZM320.48,592.12h-99.68c-14.98,0-29.61-3-42.31-8.67-5.98-2.67-12.3-4.87-18.83-6.61h158.75c3.36,4.97,7.05,10.06,10.98,14.91-2.96.24-5.94.36-8.91.36ZM343.95,589.58c-3.45-3.87-6.88-8.18-10.22-12.73h50.23c-3.18.84-6.31,1.77-9.35,2.83l-19.12,6.66c-3.72,1.3-7.59,2.37-11.55,3.23ZM565.53,600.26c-10.84,3.68-18.68,6.35-30.09,6.35h-166.1c-2.12,0-4.37-.59-6.7-1.63,1.08-.34,2.17-.67,3.23-1.04l19.12-6.67c10.84-3.78,22.95-5.78,35.02-5.78h112.83l48.32,3.77c-5.91,1.7-10.98,3.42-15.62,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M388.31,481.12h0c-2.95,0-5.34-2.39-5.34-5.34v-178.18c0-2.95,2.39-5.34,5.34-5.34h0c2.95,0,5.34,2.39,5.34,5.34v178.18c0,2.95-2.39,5.34-5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M251.48,316.24c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M87.88,356.38c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M125.5,259.98h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 274.8,
    y: 259.98,
    width: 63.55,
    height: 113.32,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M274.8,345.32v16.89c0,6.13,4.97,11.09,11.09,11.09h41.37c6.13,0,11.09-4.97,11.09-11.09v-16.89h-63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M138.01,356.95l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.09,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.59c9.13-2.4,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M369.19,526.98v108.78c0,15.09,1.6,18.96,6.78,30.3,3.46,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M414.27,448.39h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M399,478.27h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-147",
    cx: 414.79,
    cy: 461.49,
    r: 34.46,
    transform: "translate(-163.67 236.95) rotate(-26.84)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 414.79,
    cy: 461.49,
    r: 27.78,
    transform: "translate(-204.84 428.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-146",
    cx: 414.79,
    cy: 461.49,
    r: 21.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-148",
    cx: 414.79,
    cy: 461.49,
    r: 17.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M399.44,285.6c0-4.55-3.69-8.23-8.23-8.23s-8.23,3.69-8.23,8.23v49.12h16.47v-49.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M264.18,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM264.18,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M356.47,626.8v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.23-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM264.18,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264.18,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM264.18,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M314.06,632.33c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.57-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-139",
    cx: 264.18,
    cy: 624.09,
    r: 31.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M264.18,573.43c-27.98,0-50.66,22.68-50.66,50.66s22.68,50.66,50.66,50.66,50.66-22.68,50.66-50.66-22.68-50.66-50.66-50.66ZM264.18,671.7c-26.29,0-47.61-21.31-47.61-47.61s21.31-47.61,47.61-47.61,47.61,21.31,47.61,47.61-21.31,47.61-47.61,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M264.18,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM264.18,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M314.06,632.33c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.57-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M264.18,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM264.18,673.04c-27.04,0-48.95-21.92-48.95-48.95s21.92-48.95,48.95-48.95,48.95,21.92,48.95,48.95-21.92,48.95-48.95,48.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-136",
    cx: 264.18,
    cy: 624.09,
    r: 18.8,
    transform: "translate(-397.49 770.65) rotate(-79.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "266.65 645.21 262.48 645.21 260.39 648.82 262.48 652.44 266.65 652.44 268.74 648.82 266.65 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M266.61,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "280.86 637.28 277.91 640.23 278.99 644.25 283.02 645.33 285.97 642.38 284.89 638.35 280.86 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M283.39,639.86c.8.8.8,2.1,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "285.3 621.62 285.3 625.79 288.91 627.87 292.52 625.79 292.52 621.62 288.91 619.53 285.3 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M288.91,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "277.36 607.41 280.31 610.36 284.34 609.28 285.42 605.25 282.47 602.3 278.44 603.38 277.36 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M279.94,604.88c.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "261.7 602.97 265.87 602.97 267.96 599.36 265.87 595.74 261.7 595.74 259.62 599.36 261.7 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M261.74,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "247.49 610.91 250.44 607.96 249.36 603.93 245.33 602.85 242.38 605.8 243.46 609.83 247.49 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M244.96,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "243.05 626.56 243.05 622.39 239.44 620.31 235.83 622.39 235.83 626.56 239.44 628.65 243.05 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M239.44,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "250.99 640.77 248.04 637.82 244.01 638.9 242.93 642.93 245.88 645.88 249.91 644.8 250.99 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M248.41,643.3c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0,.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-135",
    cx: 264.18,
    cy: 624.09,
    r: 13.3,
    transform: "translate(-397.54 770.42) rotate(-79.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M945.35,598.46l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-176",
    cx: 808.19,
    cy: 624.09,
    r: 39.87,
    transform: "translate(15.11 1267.28) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M1181.81,598.46l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-176",
    cx: 1044.65,
    cy: 624.09,
    r: 39.87,
    transform: "translate(261.29 1555.29) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 893.73,
    y: 549.91,
    width: 65.43,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 885.83,
    y: 555.7,
    width: 81.24,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 877.92,
    y: 561.5,
    width: 97.06,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 870.01,
    y: 567.3,
    width: 112.87,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 862.1,
    y: 573.1,
    width: 128.68,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 854.2,
    y: 578.9,
    width: 144.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 846.29,
    y: 584.69,
    width: 160.31,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 838.38,
    y: 590.49,
    width: 176.12,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 830.48,
    y: 596.29,
    width: 191.94,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 822.57,
    y: 602.09,
    width: 207.75,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 814.66,
    y: 607.88,
    width: 223.57,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 806.76,
    y: 613.68,
    width: 239.38,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 902.91,
    y: 548.65,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 942.78,
    y: 548.65,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M907.62,613.47l7.54,34.13c.42,1.9,1.44,3.14,2.58,3.14h17.42c1.14,0,2.16-1.25,2.58-3.14l7.54-34.13c.72-3.26-.62-6.8-2.58-6.8h-32.49c-1.96,0-3.3,3.54-2.58,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M907.74,632.92c-4.44.38-8.02,3.25-9.6,7.11l-100.9,8.57.88,10.35,100.9-8.57c2.21,3.53,6.23,5.77,10.66,5.39,6.31-.54,10.99-6.09,10.46-12.4s-6.09-10.99-12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M945.15,632.92c4.44.38,8.02,3.25,9.6,7.11l100.9,8.57-.88,10.35-100.9-8.57c-2.21,3.53-6.23,5.77-10.66,5.39-6.31-.54-10.99-6.09-10.46-12.4s6.09-10.99,12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M1188.55,670.56c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-45.37-.81-56.86h-3.32v57.23c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M923.5,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M917.26,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1160.28,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M1154.04,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-176",
    cx: 808.19,
    cy: 624.09,
    r: 39.87,
    transform: "translate(15.11 1267.28) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M807.95,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM807.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M900.24,626.8v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.86-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM807.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M807.95,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM807.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M807.95,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM807.95,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M807.95,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM807.95,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M807.92,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM775.15,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM767.11,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM786.42,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45,5.56,8.98,3.45,11.09ZM807.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM808.05,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM829.42,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM840.68,656.71c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08,8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM848.73,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M857.95,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.28,5.4-10.28s5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM782.79,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45s.57,7.07-3.45,11.08ZM807.79,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM843.95,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M772.74,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM807.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M807.92,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM775.15,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM767.11,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM786.42,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45,5.56,8.98,3.45,11.09ZM807.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM808.05,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM829.42,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM840.68,656.71c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08,8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM848.73,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "810.42 645.21 806.25 645.21 804.16 648.82 806.25 652.44 810.42 652.44 812.51 648.82 810.42 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M810.38,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "824.63 637.28 821.68 640.23 822.76 644.25 826.79 645.33 829.74 642.38 828.66 638.35 824.63 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M827.16,639.86c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "829.07 621.62 829.07 625.79 832.68 627.87 836.29 625.79 836.29 621.62 832.68 619.53 829.07 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M832.68,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "821.13 607.41 824.08 610.36 828.11 609.28 829.19 605.25 826.24 602.3 822.21 603.38 821.13 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M823.71,604.88c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "805.47 602.97 809.64 602.97 811.73 599.36 809.64 595.74 805.47 595.74 803.39 599.36 805.47 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M805.51,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "791.26 610.91 794.21 607.96 793.13 603.93 789.1 602.85 786.15 605.8 787.23 609.83 791.26 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M788.74,608.32c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89s-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "786.83 626.56 786.83 622.39 783.21 620.31 779.6 622.39 779.6 626.56 783.21 628.65 786.83 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M783.21,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "794.76 640.77 791.81 637.82 787.78 638.9 786.7 642.93 789.65 645.88 793.68 644.8 794.76 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M792.18,643.3c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-164",
    cx: 807.95,
    cy: 624.09,
    r: 18.8,
    transform: "translate(-204.66 754.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-165",
    cx: 807.95,
    cy: 624.09,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M1044.64,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1044.64,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1136.94,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.23,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.23,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1044.64,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1044.64,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1044.64,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M1044.64,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1044.64,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M1044.64,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1044.64,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M1044.61,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1011.84,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1003.8,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM1023.11,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45s5.56,8.98,3.45,11.09ZM1044.48,577.91c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1044.74,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1066.11,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1077.38,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1085.42,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M1094.65,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.28,5.4-10.28s5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM1019.48,599.18c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45s.57,7.07-3.45,11.08ZM1044.48,588.71c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1080.64,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M1009.44,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1044.48,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1044.61,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1011.84,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1003.8,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM1023.11,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45s5.56,8.98,3.45,11.09ZM1044.48,577.91c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1044.74,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1066.11,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1077.38,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1085.42,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "1047.12 645.21 1042.95 645.21 1040.86 648.82 1042.95 652.44 1047.12 652.44 1049.2 648.82 1047.12 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1047.08,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "1061.33 637.28 1058.38 640.23 1059.46 644.25 1063.49 645.33 1066.44 642.38 1065.36 638.35 1061.33 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1063.85,639.86c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "1065.76 621.62 1065.76 625.79 1069.38 627.87 1072.99 625.79 1072.99 621.62 1069.38 619.53 1065.76 621.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-172",
    cx: 1069.38,
    cy: 623.7,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "1057.83 607.41 1060.78 610.36 1064.81 609.28 1065.89 605.25 1062.94 602.3 1058.91 603.38 1057.83 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1060.41,604.88c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "1042.17 602.97 1046.34 602.97 1048.43 599.36 1046.34 595.74 1042.17 595.74 1040.08 599.36 1042.17 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1042.21,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "1027.96 610.91 1030.91 607.96 1029.83 603.93 1025.8 602.85 1022.85 605.8 1023.93 609.83 1027.96 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1025.43,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "1023.52 626.56 1023.52 622.39 1019.91 620.31 1016.3 622.39 1016.3 626.56 1019.91 628.65 1023.52 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1019.91,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "1031.46 640.77 1028.51 637.82 1024.48 638.9 1023.4 642.93 1026.35 645.88 1030.38 644.8 1031.46 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1028.88,643.3c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 1044.64,
    cy: 624.09,
    r: 18.8,
    transform: "translate(197.24 1497.4) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 1044.64,
    cy: 624.09,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1149.99,571.72c5.24,10.56,8.91,22.04,10.71,34.12.32,2.15,2.12,3.77,4.29,3.77h14.06v-47.75h-23c-5.07,0-8.31,5.32-6.05,9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1178.11,587.56h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1178.76,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1178.87,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1177.05,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1177.16,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1175.34,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1175.45,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1178.11,565.13h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.72v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 1178.76,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1178.87,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 1177.05,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1177.16,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 1175.34,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1175.45,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M428.59,518.59h246.72c2.96,0,5.36,2.4,5.36,5.36v127.75c0,2.96-2.4,5.36-5.36,5.36h-246.72c-2.96,0-5.36-2.4-5.36-5.36v-127.75c0-2.96,2.4-5.36,5.36-5.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 439.31,
    y: 640.12,
    width: 41.2,
    height: 25.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 453.82,
    y: 513.72,
    width: 12.19,
    height: 149.2,
    rx: 4.88,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M459.91,662.92h0c-2.15,0-3.9-1.75-3.9-3.9v-141.4c0-2.15,1.75-3.9,3.9-3.9h0c2.15,0,3.9,1.75,3.9,3.9v141.4c0,2.15-1.75,3.9-3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 531.35,
    y: 640.12,
    width: 41.2,
    height: 25.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 545.85,
    y: 513.72,
    width: 12.19,
    height: 149.2,
    rx: 4.88,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M551.95,662.92h0c-2.15,0-3.9-1.75-3.9-3.9v-141.4c0-2.15,1.75-3.9,3.9-3.9h0c2.15,0,3.9,1.75,3.9,3.9v141.4c0,2.15-1.75,3.9-3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 623.38,
    y: 640.12,
    width: 41.2,
    height: 25.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 637.89,
    y: 513.72,
    width: 12.19,
    height: 149.2,
    rx: 4.88,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M643.98,662.92h0c-2.15,0-3.9-1.75-3.9-3.9v-141.4c0-2.15,1.75-3.9,3.9-3.9h0c2.15,0,3.9,1.75,3.9,3.9v141.4c0,2.15-1.75,3.9-3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M586.62,517.17h24.4v6.06c0,5.63-4.57,10.2-10.2,10.2h-4.01c-5.63,0-10.2-4.57-10.2-10.2v-6.06h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-171",
    cx: 598.82,
    cy: 517.17,
    rx: 12.2,
    ry: 8.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-195",
    cx: 598.82,
    cy: 515.52,
    rx: 10.48,
    ry: 6.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-79",
    cx: 1148.05,
    cy: 555.37,
    r: 6.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M2986.66,685.74c-6.08-2.73-23.11-5.04-24.13-26.14-.48-9.85-.67-34.51-.81-46h-3.32v46.37c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M767.11,457.44v32.86h372.22c31.92,0,63.73,3.82,94.74,11.38l116.64,28.43c29.5,7.19,59.75,10.82,90.11,10.82h1645.73v-83.49H767.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 1298.46,
    y: 583.16,
    width: 97.35,
    height: 11.6,
    transform: "translate(-21.89 1125.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 1289.1,
    y: 510.52,
    width: 23.76,
    height: 163.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1266.14,683.19h69.68v3.54c0,2.51-2.04,4.55-4.55,4.55h-60.58c-2.51,0-4.55-2.04-4.55-4.55v-3.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1293.38,655.93l-15.72,27.23h46.63l-15.72-27.23c-3.38-5.85-11.82-5.85-15.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M1306.22,662.9c0,2.9-2.35,5.25-5.25,5.25s-5.25-2.35-5.25-5.25,2.35-5.25,5.25-5.25,5.25,2.35,5.25,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1292.53,494.97h16.9c7.16,0,12.98,5.82,12.98,12.98v130.64h-42.86v-130.64c0-7.16,5.82-12.98,12.98-12.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1296.51,512.29c0,3.31-2.68,6-6,6s-6-2.68-6-6,2.68-6,6-6,6,2.68,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1314.61,530.39c0,3.31-2.68,6-6,6s-6-2.68-6-6,2.68-6,6-6,6,2.68,6,6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 2728.32,
    y: 615.16,
    width: 88.38,
    height: 8.74,
    transform: "translate(281.29 -745.93) rotate(16.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 2484.96,
    y: 615.16,
    width: 88.38,
    height: 8.74,
    transform: "translate(271.71 -678.31) rotate(16.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M2711.87,579.05l-4.43-8.5c-2.04-3.9-6.85-5.42-10.76-3.38h0c-3.91,2.04-5.42,6.85-3.38,10.76l2.61,5h-86.63v-.37h-14.17v.37h-86.63l2.61-5c2.04-3.9.52-8.72-3.38-10.76h0c-3.9-2.04-8.72-.52-10.76,3.38l-4.43,8.5c-2.04,3.9-.52,8.72,3.38,10.75h0c3.52,1.84,7.76.77,10.06-2.32h20.08v2.28h7.89v2.28h12.5v2.28h13.82v2.28h17.77v2.28h17.08v1.49h14.17v-1.49h17.08v-2.28h17.77v-2.28h13.82v-2.28h12.5v-2.28h7.89v-2.28h20.08c2.3,3.09,6.54,4.16,10.06,2.32h0c3.91-2.04,5.42-6.85,3.38-10.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-176",
    cx: 2602.44,
    cy: 624.09,
    r: 39.87,
    transform: "translate(1569.55 3092.96) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M2602.2,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2602.2,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2694.49,626.8v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2602.2,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2602.2,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2602.2,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M2602.2,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2602.2,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M2602.2,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2602.2,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2602.16,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2569.4,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2561.35,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM2580.67,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2602.03,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2602.29,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM2623.66,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2634.93,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2642.97,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M2652.2,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.28,5.4-10.28s5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2577.03,599.18c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45s.57,7.07-3.45,11.08ZM2602.03,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2638.2,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M2566.99,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2602.03,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M2602.16,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2569.4,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2561.35,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM2580.67,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2602.03,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2602.29,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM2623.66,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2634.93,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2642.97,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2604.67 645.21 2600.5 645.21 2598.41 648.82 2600.5 652.44 2604.67 652.44 2606.76 648.82 2604.67 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2604.63,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2618.88 637.28 2615.93 640.23 2617.01 644.25 2621.04 645.33 2623.99 642.38 2622.91 638.35 2618.88 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2621.41,639.86c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2623.32 621.62 2623.32 625.79 2626.93 627.87 2630.54 625.79 2630.54 621.62 2626.93 619.53 2623.32 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2626.93,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2615.38 607.41 2618.33 610.36 2622.36 609.28 2623.44 605.25 2620.49 602.3 2616.46 603.38 2615.38 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2617.96,604.88c.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2599.72 602.97 2603.89 602.97 2605.98 599.36 2603.89 595.74 2599.72 595.74 2597.64 599.36 2599.72 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2599.76,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2585.51 610.91 2588.46 607.96 2587.38 603.93 2583.35 602.85 2580.4 605.8 2581.48 609.83 2585.51 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2582.99,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2581.08 626.56 2581.08 622.39 2577.46 620.31 2573.85 622.39 2573.85 626.56 2577.46 628.65 2581.08 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2577.46,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2589.01 640.77 2586.06 637.82 2582.03 638.9 2580.95 642.93 2583.9 645.88 2587.93 644.8 2589.01 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2586.43,643.3c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0s.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 2602.2,
    cy: 624.09,
    r: 18.8,
    transform: "translate(1396.94 3013.29) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 2602.2,
    cy: 624.09,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M2952.63,579.05l-4.43-8.5c-2.04-3.9-6.85-5.42-10.76-3.38h0c-3.9,2.04-5.42,6.85-3.38,10.76l2.61,5h-86.63v-.37h-14.17v.37h-86.63l2.61-5c2.04-3.9.52-8.72-3.38-10.76h0c-3.9-2.04-8.72-.52-10.76,3.38l-4.43,8.5c-2.04,3.9-.52,8.72,3.38,10.75h0c3.52,1.84,7.76.77,10.06-2.32h20.08v2.28h7.89v2.28h12.5v2.28h13.82v2.28h17.77v2.28h17.08v1.49h14.17v-1.49h17.08v-2.28h17.77v-2.28h13.82v-2.28h12.5v-2.28h7.89v-2.28h20.08c2.3,3.09,6.54,4.16,10.06,2.32h0c3.91-2.04,5.42-6.85,3.38-10.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-176",
    cx: 2843.2,
    cy: 624.09,
    r: 39.87,
    transform: "translate(1771.74 3330.61) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M2842.95,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2842.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2935.25,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2842.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2842.95,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2842.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M2842.95,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2842.95,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M2842.95,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2842.95,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M2842.92,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2810.15,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2802.11,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM2821.42,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45,5.56,8.98,3.45,11.09ZM2842.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM2843.05,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2864.42,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2875.69,656.71c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2883.73,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M2892.96,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.28,5.4-10.28s5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2817.79,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45s.57,7.07-3.45,11.08ZM2842.79,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2878.95,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M2807.75,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2842.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M2842.92,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2810.15,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2802.11,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM2821.42,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45,5.56,8.98,3.45,11.09ZM2842.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM2843.05,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2864.42,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2875.69,656.71c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2883.73,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2845.42 645.21 2841.25 645.21 2839.17 648.82 2841.25 652.44 2845.42 652.44 2847.51 648.82 2845.42 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2845.39,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2859.63 637.28 2856.68 640.23 2857.76 644.25 2861.79 645.33 2864.74 642.38 2863.66 638.35 2859.63 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2862.16,639.86c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2864.07 621.62 2864.07 625.79 2867.68 627.87 2871.3 625.79 2871.3 621.62 2867.68 619.53 2864.07 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2867.68,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2856.14 607.41 2859.09 610.36 2863.11 609.28 2864.19 605.25 2861.24 602.3 2857.21 603.38 2856.14 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2858.72,604.88c.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2840.48 602.97 2844.65 602.97 2846.73 599.36 2844.65 595.74 2840.48 595.74 2838.39 599.36 2840.48 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2840.52,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2826.27 610.91 2829.22 607.96 2828.14 603.93 2824.11 602.85 2821.16 605.8 2822.24 609.83 2826.27 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2823.74,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2821.83 626.56 2821.83 622.39 2818.22 620.31 2814.6 622.39 2814.6 626.56 2818.22 628.65 2821.83 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2818.22,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "2829.77 640.77 2826.82 637.82 2822.79 638.9 2821.71 642.93 2824.66 645.88 2828.69 644.8 2829.77 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M2827.18,643.3c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0s.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 2842.95,
    cy: 624.09,
    r: 18.8,
    transform: "translate(1582.38 3247.6) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 2842.95,
    cy: 624.09,
    r: 13.18
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2735.51 620.33 2710.2 620.33 2694.49 544.39 2748.82 544.39 2735.51 620.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2948.35,580.58h-10.29l-16.86-36.19h43.48l-4.28,25.96c-.97,5.9-6.07,10.22-12.05,10.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M2958.4,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M2952.16,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 2722.04,
    cy: 567.74,
    r: 9.26,
    transform: "translate(1544.09 3086.52) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2466.84,544.39l5.86,62.92c.69,7.38,6.88,13.02,14.29,13.02h2.92l37.08-75.94h-60.14ZM2491.61,598.82c-5.11,0-9.26-4.15-9.26-9.26s4.15-9.26,9.26-9.26,9.26,4.15,9.26,9.26-4.15,9.26-9.26,9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M2717.64,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M2711.4,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2482.35,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2496.24,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 2482.35,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 2496.24,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 2710.93,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 2724.82,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 2710.93,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 2724.82,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 2939.51,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 2953.39,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M2526.71,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M2691.45,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M2767.57,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M2932.3,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M520.19,508.64c-.43,0-.87,0-1.31-.02-1.1-.03-1.97-.95-1.94-2.06.03-1.1,1.01-1.99,2.06-1.94,15.42.5,24.15-7.9,32.6-15.98,7.03-6.72,13.67-13.07,23.48-13.89,7.96-.72,12.67,4.09,16.44,7.91,2.96,3,4.73,4.65,6.8,4.12,3.87-1.01,3.65-7.02,2.95-14.77-.59-6.54-1.14-12.71,3.64-13.66,4.73-.94,6.97,4.44,9.33,10.15,2.16,5.21,4.6,11.11,8.51,11.11.04,0,.09,0,.13,0,.85-.03,1.23-.33,1.46-.59,1.65-1.86,1.15-7.63.75-12.27-.6-6.93-1.16-13.48,3.8-14.36,5.12-.94,7.49,6.12,9.99,13.54,1.74,5.17,4.13,12.25,6.63,12.33.24.04.32-.04.43-.15,1.49-1.47,1.41-7.93,1.35-12.65-.1-8.01-.19-14.93,4.74-15.12,5.17-.14,7.45,8.16,9.86,17.03.71,2.59,1.61,5.9,2.37,7.75.78-2.16,1.66-6.24,2.3-9.17,2.04-9.46,3.81-17.64,8.4-17.64h.04c4.36.04,4.72,6.43,5.18,14.52.28,5.04.82,14.42,3.1,14.49.01,0,.02,0,.03,0,2.22,0,4.16-8.04,5.33-12.85,1.54-6.35,2.87-11.84,5.83-13.61.99-.59,2.1-.75,3.22-.46,4.93,1.28,5.46,8.22,6.02,15.55.34,4.47.81,10.59,2.64,11.62,1.19.65,3.08-1.53,5.63-4.71,3.26-4.09,7.33-9.17,12.88-7.52,2.53.75,4.4,2.52,6.57,4.56,5.81,5.48,15.54,14.65,51.82,16.05,1.1.04,1.96.97,1.92,2.07-.04,1.1-.99,2.03-2.07,1.92-37.78-1.45-48.19-11.27-54.41-17.14-1.94-1.83-3.34-3.15-4.96-3.64-2.77-.82-5.31,2.05-8.61,6.18-3.03,3.79-6.46,8.09-10.71,5.7-3.7-2.08-4.17-8.26-4.67-14.8-.37-4.82-.88-11.43-3.04-11.99-1.69.93-3.12,6.84-4.16,11.15-1.98,8.18-3.85,15.9-9.19,15.9-.06,0-.12,0-.18,0-5.94-.19-6.46-9.38-6.97-18.27-.21-3.71-.52-9.19-1.39-10.63-1.51,1.32-3.33,9.76-4.33,14.37-1.87,8.64-2.9,13.42-6.12,13.42h-.06c-3.05-.05-4.19-4.23-6.25-11.8-1.05-3.86-3.83-14.08-5.83-14.08h-.02c-1.03.85-.95,7.26-.9,11.08.09,6.63.17,12.89-2.55,15.55-.91.89-2.08,1.31-3.36,1.3-5.27-.17-7.71-7.39-10.29-15.05-1.32-3.91-3.73-11.08-5.51-10.89-1.35.24-.78,6.89-.51,10.08.51,5.96,1.04,12.13-1.74,15.27-1.07,1.21-2.57,1.88-4.32,1.94-6.77.14-9.92-7.43-12.47-13.58-1.41-3.4-3.35-8.14-4.85-7.76-1.26.25-.73,6.2-.44,9.39.68,7.59,1.53,17.04-5.92,18.99-4.41,1.14-7.59-2.07-10.66-5.18-3.52-3.56-7.12-7.2-13.26-6.74-8.41.71-14.55,6.58-21.05,12.8-8.4,8.03-17.89,17.11-34.16,17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M453.82,389.25v91.35h70.94v-91.35h-70.94ZM503.59,446.54c0,5.57-6.4,10.09-14.3,10.09s-14.3-4.52-14.3-10.09v-33.67c0-5.57,6.4-10.09,14.3-10.09s14.3,4.52,14.3,10.09v33.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M453.82,378.02v114.26h70.94v-114.26h-70.94ZM503.59,449.67c0,6.97-6.4,12.61-14.3,12.61s-14.3-5.65-14.3-12.61v-42.11c0-6.97,6.4-12.62,14.3-12.62s14.3,5.65,14.3,12.62v42.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M453.82,372.54v129.54h70.94v-129.54h-70.94ZM503.59,453.78c0,7.9-6.4,14.3-14.3,14.3s-14.3-6.4-14.3-14.3v-47.74c0-7.9,6.4-14.3,14.3-14.3s14.3,6.4,14.3,14.3v47.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M470.14,492.68c0,3.21-2.6,5.82-5.82,5.82s-5.82-2.6-5.82-5.82,2.6-5.82,5.82-5.82,5.82,2.6,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M468.44,492.68c0,2.27-1.84,4.11-4.11,4.11s-4.11-1.84-4.11-4.11,1.84-4.11,4.11-4.11,4.11,1.84,4.11,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M520.07,492.68c0,3.21-2.6,5.82-5.82,5.82s-5.82-2.6-5.82-5.82,2.6-5.82,5.82-5.82,5.82,2.6,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-195",
    cx: 514.26,
    cy: 492.68,
    r: 4.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3055.65,502.25h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M3090.83,527.94h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.72v-7.36c0-3.16,2.56-5.72,5.72-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 3091.47,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3091.58,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 3089.76,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3089.87,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 3088.05,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3088.16,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M3090.83,505.52h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.71v-7.36c0-3.16,2.56-5.72,5.72-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 3091.47,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 3091.58,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 3089.76,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 3089.87,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 3088.05,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M3088.51,507.24h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 3063.71,
    y: 478.98,
    width: 15.99,
    height: 71.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 3071.7,
    y: 457.44,
    width: 15.99,
    height: 171.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 3071.7,
    y: 574.21,
    width: 15.99,
    height: 55.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M358.13,246.19c-3-8.99-13.79-25.78-34.17-28.78-20.38-3-206.85,2.4-218.24,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.24,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM242.02,363.06c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM338.35,362.2c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.15,434.76c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,21.96.15,32.77.43v-6.3c-10.81-.28-21.73-.43-32.77-.43Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 340,
    height: 81,
    transform: "translate(30.39 440.94)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "168.54 521.19 36.87 521.19 36.87 594.03 69.75 594.03 69.75 633.1 77.54 633.1 77.54 594.03 119.51 594.03 119.51 633.1 127.3 633.1 127.3 594.03 138.96 594.03 168.54 521.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "136.02 568.75 69.75 568.75 69.75 528.58 154.28 528.58 136.02 568.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 67.8,
    y: 626.53,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M123.79,208.5h219.58v24.37H99.63v-.21c0-13.34,10.83-24.16,24.16-24.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M360.3,206.55V50.36s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45l260.59-24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M360.3,216.88v-72.11s-216.57,51.79-239.8,66.84c-23.23,15.04-20.79,21.26-20.79,21.26l260.59-15.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M128.48,564.15h-46.45c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 67.8,
    y: 623.24,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M65.35,633.1H31.17c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 765.14,
    width: 2328.31,
    height: 484.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 772.04,
    y: 6,
    width: 2314.51,
    height: 472.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "776.37 8.79 3086.55 8.79 3086.55 6 772.04 6 772.04 478.98 776.37 478.98 776.37 8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M358.13,246.19c-1.84-5.52-6.63-13.96-14.75-20.36v-7.91l16.92-1.04V50.36s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45h.01c-.02.26-.03.53-.04.8-.04.3-.05.53-.04.71,0,.07,0,.13,0,.2v.21h.45c-19.11,34.37-68.71,171.94-68.71,198.37,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.23,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM242.02,363.06c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.58c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM338.35,362.2c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 210.85,
    y: 419.28,
    width: 39.07,
    height: 16.37,
    rx: 8.19,
    ry: 8.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 215.55,
    y: 423.89,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M208.82,423.89h7.62v7.14h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M246.39,423.89h7.62v7.14h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57Z",
    transform: "translate(496.84 854.93) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 216.97,
    y: 424.89,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 76.19,
    y: 502.95,
    width: 20.71,
    height: 12.88,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 77.32,
    y: 503.89,
    width: 18.45,
    height: 11,
    rx: 2.33,
    ry: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 92.89,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.08,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 89.92,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.11,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 86.94,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.14,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 83.97,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.16,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 81,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.19,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 78.03,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.22,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M18.53,393.26c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M9.49,363.1c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.21-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M130,253.18h-4.65c-.96,0-1.78.58-2.17,1.4H25.75c-13.21,0-23.95,10.75-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.25-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H4.19v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-183",
    cx: 17.58,
    cy: 310.34,
    rx: 6.1,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M18.35,267.81h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M10,276.08h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 2933.47,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.12,
    ry: 2.12,
    transform: "translate(5898.26 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 2934.85,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(5883.57 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2935.38,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5872.39 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2935.78,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5872.65 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2937.62,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5876.87 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2938.02,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5877.12 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2939.85,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5881.34 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2940.25,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5881.59 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2942.09,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5885.81 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2942.49,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5886.07 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2944.33,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5890.28 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2944.73,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5890.54 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2946.56,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5894.75 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2946.96,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5895.01 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2949.54,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(5912.96 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2950.07,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5901.78 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2950.47,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5902.03 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2952.77,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(5906.25 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2952.71,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5906.5 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2954.54,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5910.72 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2954.94,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5910.97 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2956.78,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5915.19 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2957.18,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5915.45 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2959.02,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5919.66 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2959.42,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5919.92 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2961.25,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5924.13 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2961.65,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5924.39 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 2219.37,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.12,
    ry: 2.12,
    transform: "translate(4470.07 989.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 2220.75,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(4455.38 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2221.28,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4444.2 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2221.68,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4444.45 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2223.52,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4448.67 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2223.92,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4448.92 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2225.76,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4453.14 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2226.15,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4453.4 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2227.99,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4457.61 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2228.39,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4457.87 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2230.69,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(4462.08 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2230.63,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4462.34 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2232.46,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4466.56 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2232.86,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4466.81 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2235.44,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(4484.76 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2235.97,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4473.58 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2236.37,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4473.83 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2238.21,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4478.05 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2238.61,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4478.31 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2240.45,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4482.52 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2240.85,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4482.78 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2242.68,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4486.99 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2243.08,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4487.25 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2244.92,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4491.47 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2245.32,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4491.72 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2247.15,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4495.94 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2247.55,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4496.19 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 1505.27,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.12,
    ry: 2.12,
    transform: "translate(3041.87 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 1506.65,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(3027.18 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 1507.18,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3016 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1507.58,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3016.25 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 1509.42,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3020.47 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1509.82,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3020.73 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 1511.66,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3024.94 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1512.06,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3025.2 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 1513.89,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3029.41 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1514.29,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3029.67 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 1516.13,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3033.89 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1516.53,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3034.14 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 1518.36,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3038.36 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1518.76,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3038.61 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1521.34,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(3056.56 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1521.88,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3045.38 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1522.27,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3045.64 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1524.11,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3049.85 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1524.51,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3050.11 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1526.35,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3054.32 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1526.75,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3054.58 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1528.58,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3058.8 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1528.98,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3059.05 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1530.82,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3063.27 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.22,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3063.52 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1533.05,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3067.74 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1533.45,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3068 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 791.17,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.12,
    ry: 2.12,
    transform: "translate(1613.67 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 792.55,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(1598.98 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 793.09,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1587.8 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 793.49,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1588.06 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 795.32,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1592.27 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 795.72,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1592.53 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 797.56,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1596.75 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 797.96,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1597 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 799.79,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1601.22 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 800.19,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1601.47 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 802.03,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1605.69 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 802.43,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1605.94 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 804.27,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1610.16 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 804.66,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1610.42 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 807.24,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(1628.36 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 807.78,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1617.18 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 808.18,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1617.44 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 810.01,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1621.66 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 810.41,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1621.91 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 812.25,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1626.13 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 812.65,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1626.38 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 814.48,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1630.6 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 814.88,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1630.85 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 816.72,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1635.07 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 817.12,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1635.33 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 818.96,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1639.54 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 819.36,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1639.8 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M383.6,535.42c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.1c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M359.1,249.49H119.55c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h100.96c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M388.31,533.18c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.9,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M30.75,473.62h0c-.26,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M44.27,485.94c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M41.57,434.27c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M94.38,418.55c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.39-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM125.5,261.18c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M327.26,374.5h-41.37c-6.78,0-12.29-5.51-12.29-12.29v-91.13c0-6.78,5.51-12.29,12.29-12.29h41.37c6.78,0,12.29,5.51,12.29,12.29v91.13c0,6.78-5.51,12.29-12.29,12.29ZM285.89,261.18c-5.45,0-9.89,4.44-9.89,9.89v91.13c0,5.45,4.44,9.89,9.89,9.89h41.37c5.45,0,9.89-4.44,9.89-9.89v-91.13c0-5.45-4.44-9.89-9.89-9.89h-41.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M36.63,440.45h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1622.81,666.29h0c-1.99,0-3.61-1.61-3.61-3.61v-53.66c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v53.66c0,1.99-1.62,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 1913.06,
    y: 605.41,
    width: 7.21,
    height: 60.88,
    rx: 3.61,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2210.52,666.29h0c-1.99,0-3.61-1.61-3.61-3.61v-53.66c0-1.99,1.62-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v53.66c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1769.74,662.69h0c-1.99,0-3.61-1.61-3.61-3.61v-160.5c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.62,3.61,3.61v160.5c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M2063.59,662.69h0c-1.99,0-3.61-1.61-3.61-3.61v-160.5c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.62,3.61,3.61v160.5c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1475.87,612.6h881.59c1.99,0,3.6-1.61,3.6-3.6s-1.61-3.6-3.6-3.6h-881.59c-1.99,0-3.6,1.61-3.6,3.6s1.61,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1475.87,558.92h881.59c1.99,0,3.6-1.61,3.6-3.6s-1.61-3.6-3.6-3.6h-881.59c-1.99,0-3.6,1.61-3.6,3.6s1.61,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1499.58,666.29h834.16c15.06,0,27.31-12.25,27.31-27.31v-140.41c0-1.99-1.61-3.6-3.6-3.6s-3.6,1.61-3.6,3.6v140.41c0,11.09-9.02,20.11-20.11,20.11h-834.16c-11.09,0-20.11-9.02-20.11-20.11v-140.41c0-1.99-1.61-3.6-3.6-3.6s-3.6,1.61-3.6,3.6v140.41c0,15.06,12.25,27.31,27.31,27.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M1586.3,612.6h32.91v46.49h-32.91v7.2h73.42v-7.2h-33.29v-46.49h33.29v-7.19h-73.42v7.19ZM1472.27,638.98c0,15.06,12.25,27.31,27.31,27.31h13.3v-7.2h-13.3c-11.09,0-20.11-9.02-20.11-20.11v-26.38h33.41v-7.19h-40.61v33.57ZM2320.45,605.41v7.19h33.41v26.38c0,11.09-9.02,20.11-20.11,20.11h-13.3v7.2h13.3c15.06,0,27.31-12.25,27.31-27.31v-33.57h-40.61ZM1879.96,612.6h33.1v46.49h-33.1v7.2h73.42v-7.2h-33.1v-46.49h33.1v-7.19h-73.42v7.19ZM1733.13,612.6h33v46.48s0,0,0,0h-33v7.2h73.42v-7.2h-33.2s0,0,0,0v-46.48h33.2v-7.19h-73.42v7.19ZM2173.62,612.6h33.29v46.49h-33.29v7.2h73.42v-7.2h-32.91v-46.49h32.91v-7.19h-73.42v7.19ZM2026.79,612.6h33.2v46.48s0,0,0,0h-33.2v7.2h73.42v-7.2h-33s0,0,0,0v-46.48h33v-7.19h-73.42v7.19Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5AxTandemTandem);
export default __webpack_public_path__ + "static/media/5-Ax Tandem-Tandem.f093e921dd9872278b554f0cf31d01eb.svg";
export { ForwardRef as ReactComponent };